﻿import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import Circle from 'ol/geom/Circle.js';
import Feature from 'ol/Feature.js';
import Collection from 'ol/Collection.js';
import VectorSource from 'ol/source/Vector.js';
import { Utility } from '../Utility.js';
import { Upload } from '../upload.js';
export { DepositionPointTool };

/**
 * Class DepositionPointTool
 */
const DepositionPointTool = function () {

    // Define this
    var myDepositionPointTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Upload attachment
    this._uploadAttachtment = null;

    // Already initialize
    this._toolInitialize = false;

    // Hash that contains all reference 
    this._hashReference = {};

    // Feature to save
    this._featureInfo = null;

    // Geojson Format
    this._geojsonFormat = new GeoJSON();

    // Tipos Equipamento table counter/id
    this._equipamentosRowCounter = 0;

    // Producer table counter/id
    this._producerRowCounter = 0;

    // Intervenções table counter/id
    this._intervencoesRowCounter = 0;

    // Observações table counter/id
    this._observacoesRowCounter = 0;

    // Layer information used in deposition point tool
    this._layerInformation = {};

    // Radius deposition search
    this._radiusSearch = 200;

    // Type deposition point to change compartimento
    this._idTypeDepositionCompartimento = "2";

    // Object with the entity selected for producer
    this._entitySelectedForProducer = null;

    // Deposition point identifier column name
    this._depositionPointIdColumnName = "";

    // Equipment datatable
    this._equipmentDatatable = null;
    this._equipmentDpDatatable = null;
    this._producerDatatable = null;
    this._typeEquipmentDatatable = null;
    this._equipmentInterventionDatatable = null;
    this._depositionPointObservationDatatable = null;

    // Hash for reference combo
    this._hashReferenceCombo = {
        section: {}
    };

    // Hash for column table desfinition
    this._hashColumDefinition = {
        column_definition: [],
        column_equipment_dp_definition: [],
        column_producer_definition: [],
        column_equipment_intervention_definition: [],
        column_deposition_point_observation_definition: []
    };

    // Definition column of equipment type
    this._hashColumDefinition.column_definition.push({
        'data': "idTipoEquipamento",
        'type': 'readonly',
        'visible': false
    });
    this._hashColumDefinition.column_definition.push({
        'data': 'tipoEquipamento',
        'title': 'Tipo de Equipamento',
        'name': 'Tipo de Equipamento',
        'label': 'Tipo de Equipamento',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_definition.push({
        'data': 'tipoFluxo',
        'title': 'Tipo de Fluxo',
        'name': 'Tipo de Fluxo',
        'label': 'Tipo de Fluxo',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_definition.push({
        'data': 'tipoCapacidadeContentor',
        'title': 'Capacidade',
        'name': 'Capacidade',
        'label': 'Capacidade',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });

    // Definition column of equipment of a deposition point
    this._hashColumDefinition.column_equipment_dp_definition.push({
        'name': 'button_config_element',
        'data': null,
        'orderable': false,
        'className': 'dt-body-center',
        'defaultContent': '<a class="button-detail-equipment" title="Ir para o detalhe do equipamento"><i class="fa fa-edit" style="color: #ff3d00"></i></a>',
        'width': '3%'
    });
    this._hashColumDefinition.column_equipment_dp_definition.push({
        'name': 'button_config_element',
        'data': null,
        'orderable': false,
        'className': 'dt-body-center',
        'defaultContent': '<a class="button-remove-equipment" title="Desassociar o equipamento do ponto de deposição"><i class="fa fa-trash-o" style="color: #ff3d00"></i></a>',
        'width': '3%'
    });
    this._hashColumDefinition.column_equipment_dp_definition.push({
        'data': "idEquipamento",
        'type': 'readonly',
        'visible': false
    });
    this._hashColumDefinition.column_equipment_dp_definition.push({
        'data': 'equipamento',
        'title': 'Equipamento',
        'name': 'Equipamento',
        'label': 'Equipamento',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_equipment_dp_definition.push({
        'data': "idTipoEquipamento",
        'type': 'readonly',
        'visible': false
    });
    this._hashColumDefinition.column_equipment_dp_definition.push({
        'data': 'tipoEquipamento',
        'title': 'Tipo',
        'name': 'Tipo',
        'label': 'Tipo',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_equipment_dp_definition.push({
        'data': 'tipoFluxo',
        'title': 'Fluxo',
        'name': 'Fluxo',
        'label': 'Fluxo',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_equipment_dp_definition.push({
        'data': 'tipoCapacidadeContentor',
        'title': 'Capacidade',
        'name': 'Capacidade',
        'label': 'Capacidade',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_equipment_dp_definition.push({
        'data': 'quantidade',
        'title': 'Quantidade',
        'name': 'Quantidade',
        'label': 'Quantidade',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_equipment_dp_definition.push({
        'name': 'button_config_element',
        'data': null,
        'orderable': false,
        'className': 'dt-body-center',
        'defaultContent': '<div><a class="button-increase-equipment-quantity" title="Incrementar quantidade"><i class="fa fa-chevron-up" style="color: #ff3d00"></i></a></div>' +
                          '<div><a class="button-decrease-equipment-quantity" title="Decrementar quantidade"><i class="fa fa-chevron-down" style="color: #ff3d00"></i></a></div>',
        'width': '3%'
    });


    // Definition column producer
    this._hashColumDefinition.column_producer_definition.push({
        'name': 'button_config_element',
        'data': null,
        'orderable': false,
        'className': 'dt-body-center',
        'defaultContent': '<a class="button-detail-deposition-point-producer" title="Editar o produtor"><i class="fa fa-edit" style="color: #ff3d00"></i></a>',
        'width': '3%'
    });
    this._hashColumDefinition.column_producer_definition.push({
        'name': 'button_config_element',
        'data': null,
        'orderable': false,
        'className': 'dt-body-center',
        'defaultContent': '<a class="button-remove-deposition-point-producer" title="Remover o produtor"><i class="fa fa-trash-o" style="color: #ff3d00"></i></a>',
        'width': '3%'
    });
    this._hashColumDefinition.column_producer_definition.push({
        'data': "idProdutor",
        'type': 'readonly',
        'visible': false
    });
    this._hashColumDefinition.column_producer_definition.push({
        'data': "idEntidade",
        'type': 'readonly',
        'visible': false
    });
    this._hashColumDefinition.column_producer_definition.push({
        'data': 'entidade',
        'title': 'Entidade',
        'name': 'Entidade',
        'label': 'Entidade',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_producer_definition.push({
        'data': "idTipoCliente",
        'type': 'readonly',
        'visible': false
    });
    this._hashColumDefinition.column_producer_definition.push({
        'data': 'tipoCliente',
        'title': 'Tipo de Cliente',
        'name': 'Tipo de Cliente',
        'label': 'Tipo de Cliente',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_producer_definition.push({
        'data': 'fraccao',
        'title': 'Fracção',
        'name': 'Fracção',
        'label': 'Fracção',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_producer_definition.push({
        'data': "idPontoDeposicao",
        'type': 'readonly',
        'visible': false
    });

    // Definition column of equipment intervention
    this._hashColumDefinition.column_equipment_intervention_definition.push({
        'name': 'button_config_element',
        'data': null,
        'orderable': false,
        'className': 'dt-body-center',
        'defaultContent': '<a class="button-detail-equipment-intervention" title="Editar a intervenção"><i class="fa fa-edit" style="color: #ff3d00"></i></a>',
        'width': '3%'
    });
    this._hashColumDefinition.column_equipment_intervention_definition.push({
        'name': 'button_config_element',
        'data': null,
        'orderable': false,
        'className': 'dt-body-center',
        'defaultContent': '<a class="button-remove-equipment-intervention" title="Remover a intervenção"><i class="fa fa-trash-o" style="color: #ff3d00"></i></a>',
        'width': '3%'
    });
    this._hashColumDefinition.column_equipment_intervention_definition.push({
        'data': "idEquipamentoIntervencao",
        'type': 'readonly',
        'visible': false
    });
    this._hashColumDefinition.column_equipment_intervention_definition.push({
        'data': 'equipamentoIntervencao',
        'title': 'Intervenção',
        'name': 'Intervenção',
        'label': 'Intervenção',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_equipment_intervention_definition.push({
        'data': "idTipoIntervencao",
        'type': 'readonly',
        'visible': false
    });
    this._hashColumDefinition.column_equipment_intervention_definition.push({
        'data': 'tipoIntervencao',
        'title': 'Tipo',
        'name': 'Tipo',
        'label': 'Tipo',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_equipment_intervention_definition.push({
        'data': 'dataIntervencao',
        'title': 'Data',
        'name': 'Data',
        'label': 'Data',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });

    // Definition column of deposition point observation
    this._hashColumDefinition.column_deposition_point_observation_definition.push({
        'name': 'button_config_element',
        'data': null,
        'orderable': false,
        'className': 'dt-body-center',
        'defaultContent': '<a class="button-detail-deposition-point-observation" title="Editar a Observação"><i class="fa fa-edit" style="color: #ff3d00"></i></a>',
        'width': '3%'
    });
    this._hashColumDefinition.column_deposition_point_observation_definition.push({
        'name': 'button_config_element',
        'data': null,
        'orderable': false,
        'className': 'dt-body-center',
        'defaultContent': '<a class="button-remove-deposition-point-observation" title="Remover a observação"><i class="fa fa-trash-o" style="color: #ff3d00"></i></a>',
        'width': '3%'
    });
    this._hashColumDefinition.column_deposition_point_observation_definition.push({
        'data': "idPontoDeposicaoObservacao",
        'type': 'readonly',
        'visible': false
    });
    this._hashColumDefinition.column_deposition_point_observation_definition.push({
        'data': 'pontoDeposicaoObservacao',
        'title': 'Observação',
        'name': 'Observação',
        'label': 'Observação',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_deposition_point_observation_definition.push({
        'data': 'data',
        'title': 'Data',
        'name': 'Data',
        'label': 'Data',
        'type': 'readonly',
        'orderable': false,
        'width': '50px'
    });
    this._hashColumDefinition.column_deposition_point_observation_definition.push({
        'data': "idPontoDeposicao",
        'type': 'readonly',
        'visible': false
    });

    // Layer deposition name
    this._LayerDepositionName = "";

    // Template attachment
    this._fileEditorTemplateForEquipment =
        '<div id="file-row-IDFILE" class="file-row-div">' +
          '<form id="file-form-IDFILE" role="form" method="post">' +
            '<div>' +
              '<div id="file-div-IDFILE" class="file-zone-div col-xs-6 col-sm-6 col-md-6 col-lg-6" style="text-align: center;padding-bottom:15px;">' + // The file
              '</div>' + 
              '<div class="file-info-zone-div col-xs-4 col-sm-4 col-md-4 col-lg-4" style="display:none;">' + // Information File
                '<div class="row" style="margin-left: 5px;">' + // Observations
                  '<label class="input file-label-info last" title="Observa&#231;&#227;o">' +
                    '<textarea id="file-observations-IDFILE" name="observations" class="file-observation-textarea" type="text" rows="3"></textarea>' +
                  '</label>' +
                '</div>' +
                '<div class="row">' + // Data & user
                  '<label class="input file-label-info info" title="Nome">' +
                      'Adicionado por <span id="file-user-IDFILE"></span> em <span id="file-date-IDFILE"></span>' +
                  '</label>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</form>' +
        '</div>';
    this._fileEditorTemplateFileZoneDivWithExpandForEquipment = "file-zone-div col-xs-2 col-sm-2 col-md-2 col-lg-2";
    this._fileEditorTemplateFileZoneDivNoExpandForEquipment = "file-zone-div col-xs-6 col-sm-6 col-md-6 col-lg-6";

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------

    // feature colection use in road builder tool
    this.collectionFeatureSet = new Collection();

    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Execute action from adicional parameter
     */
    this.ExecuteAdicionalParameter = function () {
        // Get adicional parameters
        var addicionalParams = this._mapSgs._settings._mapSettings.additional_params;

        // Goto do police number by name
        if (addicionalParams && addicionalParams.context === "depositionPointTool" && addicionalParams.type === "gotoNpolice" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myDepositionPointTool._mapSgs.layerTree.FindLayerInfoOnListLayer("NPOLICIA");

            // Active layer police number
            myDepositionPointTool._mapSgs.layerTree.layerTreeObj.check(myDepositionPointTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myDepositionPointTool._GotoNPolice(layerInfo, addicionalParams.id);
        }
    }

    /**
     * Delete deposition point
     * @param {int} idDepositionPoint, deposition point identifier
     */
    this.DeleteDepositionPoint = function(idDepositionPoint)
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        $.ajax({
            type: 'GET',
            url: '/rest/app/DepositionPointTool/GetDeleteDepositionPoint?idDepositionPoint=' + idDepositionPoint,
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na remoção do ponto de deposição");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Refresh layer
                            myDepositionPointTool._RefreshLayerDeposition();

                            // Close offcanvas
                            $('#id-offcanvas-layer-detail .link-default').trigger('click');

                            // Close edition
                            myDepositionPointTool._mapSgs.layerTree.CloseEdition(false);

                            toastr["success"]("Ponto de deposição criado com sucesso");
                            break;
                        default:
                            toastr["error"]("Erro na criação do ponto de deposição");
                    }
                }

                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na remoção do ponto de deposição");
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Goto npolice
     * @param {object} layerInfo, All the information of the layer
     * @param {int} id, police identifier
     */
    this._GotoNPolice = function (layerInfo, id) {
        // Start wait
        myDepositionPointTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', true);

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: layerInfo.geoserver + "/wfs",
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": layerInfo.workspace + ':' + layerInfo.layerName,
                "featureID": [id].toString(),
                'srsName': myDepositionPointTool._mapSgs._settings.projection.code_,
                "outputFormat": 'application/json',
                "maxFeatures": 200
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length === 1) {
                    myDepositionPointTool._mapSgs.featureToHighLight.push((new GeoJSON()).readFeatures(data)[0]);
                    var styleElement = myDepositionPointTool._mapSgs._defaultHighlighStyles;
                    myDepositionPointTool._mapSgs.featureToHighLight.getArray()[myDepositionPointTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);

                    // Set current features in overlay
                    myDepositionPointTool._mapSgs.layerHighlightOverlay.setSource(new VectorSource({ features: myDepositionPointTool._mapSgs.featureToHighLight, useSpatialIndex: true }));

                    // Go to Feature
                    if(myDepositionPointTool._mapSgs.layerHighlightOverlay.getSource().getFeatures().length === 1 &&
                        myDepositionPointTool._mapSgs.layerHighlightOverlay.getSource().getFeatures()[0].getGeometry().getType() === "Point")
                    {
                        myDepositionPointTool._mapSgs.map.getView().fit(myDepositionPointTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myDepositionPointTool._mapSgs.map.getSize(), maxZoom: 12, duration: 1000  });
                    }
                    else
                        myDepositionPointTool._mapSgs.map.getView().fit(myDepositionPointTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myDepositionPointTool._mapSgs.map.getSize() });
                }
            }

            // Stop wait
            myDepositionPointTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
        });
    }

    /**
    * Goto npolice
    * @param {object} layerInfo, All the information of the layer
    * @param {int} id, police identifier
    */
    this._GotoPretensao = function (layerInfo, id, Type, Year, Processo) {
        // Start wait
        myDepositionPointTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', true);

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: layerInfo.geoserver + "/wfs",
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": layerInfo.workspace + ':' + layerInfo.layerName,
                "cql_filter": "TIPO == '" + Type + "' && " +
                    "PROCESSO == '" + Processo + "' &&" +
                    "ANO == '" + Year + "'",
                'srsName': myDepositionPointTool._mapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length === 1) {
                    myDepositionPointTool._mapSgs.featureToHighLight.push((new GeoJSON()).readFeatures(data)[0]);
                    var styleElement = myDepositionPointTool._mapSgs._defaultHighlighStyles;
                    myDepositionPointTool._mapSgs.featureToHighLight.getArray()[myDepositionPointTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);

                    // Set current features in overlay
                    myDepositionPointTool._mapSgs.layerHighlightOverlay.setSource(new VectorSource({ features: myDepositionPointTool._mapSgs.featureToHighLight, useSpatialIndex: true }));

                    myDepositionPointTool._mapSgs.map.getView().fit(myDepositionPointTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myDepositionPointTool._mapSgs.map.getSize() });
                }
            }

            // Stop wait
            myDepositionPointTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
        });
    }

    /**
     * Compare
     */
    this._Compare = function (a, b) {
        const posA = a.column_pos;
        const posB = b.column_pos;

        let comparison = 0;
        if (posA > posB) {
            comparison = 1;
        } else if (posA < posB) {
            comparison = -1;
        }

        return comparison;
    }

    /**
    * Get all references for deposition point tool
    */
    this._GetAllReferences = function ()
    {
        $.ajax({
            type: 'GET',
            url: '/rest/app/DepositionPointTool/GetAllReference',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento da informação de referência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myDepositionPointTool._hashReference['situacao_list'] = data.result.list_situacoes;
                            myDepositionPointTool._hashReference['tipo_list'] = data.result.list_tipos;
                            myDepositionPointTool._hashReference['utilizacao_list'] = data.result.list_utilizacoes;
                            myDepositionPointTool._hashReference['entidades_list'] = data.result.list_entidades;
                            myDepositionPointTool._hashReference['tipos_intervencao_list'] = data.result.list_tipos_intervencao;
                            myDepositionPointTool._hashReference['freguesia_troco_list'] = data.result.list_freguesia_troco;
                            myDepositionPointTool._hashReference['trocos_list'] = data.result.list_trocos;
                            myDepositionPointTool._hashReference['tipos_equipamentos_list'] = data.result.list_tipos_equipamentos;
                            myDepositionPointTool._hashReference['tipo_compartimento_list'] = data.result.list_tipo_compartimento;

                            myDepositionPointTool._utility.FillSelect('id-depositionPointToolTipo', data.result.list_tipos, 'value', 'id', true);

                            // -- Populate combo box entity in search -----------------------------
                            $('#id-depositionPointToolEntityZone').append($(
                                  '<div class="form-group offcanvas-body-layer-detail-row">'
                                + '<select title="Nenhum escolhido" class="form-control js-example-basic-single offcanvas-body-select2-layer-search" id="id-depositionPointToolEntity"><option></option></select>'
                                + '</div>'
                            ));

                            var idComboNodeEntity = 'id-depositionPointToolEntity';
                            $('#' + idComboNodeEntity).select2();
                            var $select = $('#' + idComboNodeEntity);

                            var $option = $("<option></option>");
                            $select.append($option);

                            var length = myDepositionPointTool._hashReference.entidades_list.length;
                            for (var u = 0; u < length; u++) {
                                var entityObj = myDepositionPointTool._hashReference.entidades_list[u];
                                $option = $("<option></option>", {
                                    "text": entityObj.value,
                                    "value": entityObj.id
                                });
                                $select.append($option);
                            }

                            // -- Populate intervention type combo box ----------------------------
                            myDepositionPointTool._utility.FillSelect("id-modal-deposition-point-tool-equipment-intervention-body-type-intervention", myDepositionPointTool._hashReference['tipos_intervencao_list'], 'value', 'id');

                            // -- Populate table equipment type -----------------------------------
                            let listTiposEquipamentos = myDepositionPointTool._hashReference['tipos_equipamentos_list'];

                            var columnValueArray = [];

                            listTiposEquipamentos.forEach(x => {
                                var objRow = {};

                                objRow["idTipoEquipamento"] = x.idTipoEquipamento;
                                objRow["tipoEquipamento"] = x.tipoEquipamento;
                                objRow["tipoFluxo"] = x.tipoFluxo;
                                objRow["tipoCapacidadeContentor"] = x.tipoCapacidadeContentor;

                                columnValueArray.push(objRow);
                            });

                            // Datatable for new equipament
                            if (myDepositionPointTool._equipmentDatatable != null) {

                                // Destroy table
                                myDepositionPointTool._equipmentDatatable.destroy();

                                // Empty table zone
                                $('#id-modal-deposition-point-tool-equipment-body-table-container').empty();

                                // Recreate table node
                                var tableSearch = $('<table id="id-modal-deposition-point-tool-equipment-body-table" class="table table-striped table-bordered table-hover" width="100%"></table>');
                                tableSearch.appendTo($('#id-modal-deposition-point-tool-equipment-body-table-container'));
                            }

                            myDepositionPointTool._equipmentDatatable = $('#id-modal-deposition-point-tool-equipment-body-table').DataTable({
                                "dom": '<rtip',
                                "destroy": true,
                                "language": {
                                    "emptyTable": 'Nenhum elemento',
                                    "paginate": {
                                        "previous": '<i class="fa fa-caret-left"></i>',
                                        "next": '<i class="fa fa-caret-right"></i>',
                                        "first": '<i class="fa fa-step-backward"></i>',
                                        "last": '<i class="fa fa-step-forward"></i>'
                                    }
                                },
                                "fixedHeader": true,
                                "info": false,
                                //"scrollY": $('#offcanvas-search-result-table-zone').height() - 80,
                                "scrollCollapse": false,
                                "deferRender": false,
                                "scroller": false,
                                "paging": true,
                                "pageLength": 5,
                                "ordering": false,
                                "columns": myDepositionPointTool._hashColumDefinition.column_definition,
                                "data": columnValueArray,
                                "select": false,
                                "name": "equipment_table",
                                "rowId": 'idTipoEquipamento'
                            });

                            $('#id-modal-deposition-point-tool-equipment-body-table tbody').on('click', 'tr', function () {
                                if ($(this).hasClass('selected')) {
                                    $(this).removeClass('selected');
                                }
                                else {
                                    myDepositionPointTool._equipmentDatatable.$('tr.selected').removeClass('selected');
                                    $(this).addClass('selected');
                                }
                            });

                            break;
                        case 'ERROR':
                            toastr["error"]("Erro de carregamento da informação de referência");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });

        myDepositionPointTool._hashReference['freguesia_list'] = [];

        if (myDepositionPointTool._mapSgs._hashReference['freguesia'] === undefined) {
            myDepositionPointTool._mapSgs._GetAllReference();
        };
    };

    /**
     * Save deposition point
     * @param {string} mode, write mode
     * @param {string} saveGeom, save geometry boolean
     */
    this._SaveFeature = function (mode, saveGeom)
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        let idPontoDeposicao = $("#prop_IDPONTODEPOSICAO").val();
        let pontoDeposicao = $("#prop_PONTODEPOSICAO").val();
        let idSituacao = $("#prop_IDPONTODEPOSICAOSITUACAO").val();
        let idTipoDeposicao = $("#prop_IDTIPODEPOSICAO").val();
        let freguesia = $('#prop_assoc_IDFREGUESIA option:selected').text()
        let idFreguesiaTroco = $('#prop_assoc_IDFREGUESIATROCO').val()
        let idEntidade = $("#prop_assoc_IDENTIDADE").val();
        let localizacao1 = $("#prop_LOCALIZACA").val();
        let localizacao2 = $("#prop_LOCALIZ2").val();

        var idUtilizacao = "";
        var idTipoCompartimento = "";
        if(idTipoDeposicao === myDepositionPointTool._idTypeDepositionCompartimento)
        {
            idUtilizacao = $('#prop_assoc_COMPARTIMENTO').val();    
        }
        else
        {
            idTipoCompartimento = $('#prop_assoc_COMPARTIMENTO').val();
        }

        if (freguesia === "Nenhum escolhido") {
            freguesia = "";
        }

        let geom_wkt = new WKT().writeGeometry(myDepositionPointTool._featureInfo.feature.getGeometry());
        let geom_srid = myDepositionPointTool._mapSgs._settings.projection.getCode().replace('EPSG:', '');

        let depositionPointSaveFields = {
            idPontoDeposicao: idPontoDeposicao,
            pontoDeposicao: pontoDeposicao,
            idSituacao: idSituacao,
            idTipoDeposicao: idTipoDeposicao,
            idUtilizacao: idUtilizacao,
            idTipoCompartimento: idTipoCompartimento,
            freguesia: freguesia,
            idFreguesiaTroco: idFreguesiaTroco,
            idEntidade: idEntidade,
            Localizacao1: localizacao1,
            Localizacao2: localizacao2,
            geom_wkt: geom_wkt,
            geom_srid: geom_srid,
            saveGeom: saveGeom,
            mode: mode,
            userName: myDepositionPointTool._mapSgs._settings._mapSettings.user_info.user_name
        };

        var msgReturn = "";
        switch(mode)
        {
            case "update":
                msgReturn = "gravação";
                break;
            case "create":
                msgReturn = "criação";
                break;
            default:
                // do nothing
        }

        $.ajax({
            type: 'POST',
            url: '/rest/app/DepositionPointTool/SaveDepositionPoint',
            data: JSON.stringify(depositionPointSaveFields),
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na " + msgReturn + " do ponto de deposição");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Refresh layer
                            myDepositionPointTool._RefreshLayerDeposition();

                            // Only in mode edition
                            if(mode == 'update')
                            {
                                // Close edition
                                myDepositionPointTool._mapSgs.layerTree.CloseEdition(false);
                            }

                            toastr["success"]("Sucesso na " + msgReturn + " do ponto de deposição");
                            break;
                        default:
                            toastr["error"]("Erro na " + msgReturn + " do ponto de deposição");
                    }
                }

                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na " + msgReturn + " do ponto de deposição");
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    };

    /**
     * Get Freguesia Info from point
     */
    this._GetFreguesiaInfoFromPoint = function (featurePoint) {
        var featureReturn = null;

        // Get point geojson
        var pointCoord = null;
        if (featurePoint.getGeometry().getCoordinates()[0] instanceof Array)
            pointCoord = turf.point(featurePoint.getGeometry().getCoordinates()[0]);
        else
            pointCoord = turf.point(featurePoint.getGeometry().getCoordinates());

        myDepositionPointTool.collectionFeatureSet.getArray().forEach(function (featureIn, index) {
            if (featureIn.getId().indexOf("FREGUESIA") >= 0) {
                var featureInGeoJson = myDepositionPointTool._geojsonFormat.writeFeatureObject(featureIn);
                if (turf.booleanPointInPolygon(pointCoord, featureInGeoJson)) {
                    // Get feature freguesia info
                    featureReturn = featureIn;
                }
            }
        });

        return featureReturn;
    };

    /**
     * Search deposition point
     */
    this._SearchDepositionPoints = function () {
        myDepositionPointTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Build Filter
        var cqlFilter = "";
        var descricao = $('#id-depositionPointToolDescricao').val();
        var tipo = $('#id-depositionPointToolTipo').val();
        var freguesia = $("#id-depositionPointToolFreguesia option:selected").text();
        var idEntity = $('#id-depositionPointToolEntity').val();

        if (descricao !== "") {
            var query = `PONTODEPOSICAO = '${descricao}'`;
            cqlFilter = query;
        }

        if (tipo !== "") {
            var query = `IDTIPODEPOSICAO = ${tipo}`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        if (idEntity !== "") {
            var query = `IDENTIDADE = ${idEntity}`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        if (freguesia !== "" && freguesia !== "Nenhum escolhido") {
            var query = `FREGUESIA = '${freguesia}'`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        // Get features
        var layerName = myDepositionPointTool._LayerDepositionName;
        var layerInfo = this._mapSgs.layerTree.FindLayerInfo(layerName);
        var getFeatureUrl = layerInfo.geoserver + "/wfs";
        var workspace = layerInfo.workspace;
        var cqlFilterResult = cqlFilter;

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "cql_filter": cqlFilterResult,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    if (myDepositionPointTool._mapSgs.featureToHighLight.getLength() > 0)
                        myDepositionPointTool._mapSgs.featureToHighLight.clear();

                    myDepositionPointTool._mapSgs._arraySearchLayerFeatureActive = [];

                    var feature = null;
                    var layerName = myDepositionPointTool._LayerDepositionName;
                    var idLayer = myDepositionPointTool._mapSgs.layerTree.FindLayerInfo(layerName).id;
                    var workspace = myDepositionPointTool._mapSgs.layerTree.FindLayerInfo(layerName).workspace;

                    var columnDefArray = [];
                    var columDefArrayExpand = [];
                    var columDefArrayExpandSize = [];
                    var columnValueArray = [];
                    var idPrimaryKey = null;
                    var featureHash = {};

                    for (let i = 0; i < data.features.length; i++) {
                        feature = (new GeoJSON()).readFeatures(data)[i];
                        idPrimaryKey = feature.getId().split(".")[1];
                        featureHash[idPrimaryKey] = feature;

                        // Save feature Search
                        myDepositionPointTool._mapSgs._arraySearchLayerFeatureActive.push(feature);

                        // Build column info
                        var objRow = {};
                        for (var j = 0; j < Object.keys(feature.getProperties()).length; j++) {
                            var columnName = Object.keys(feature.getProperties())[j];

                            if (columnName === "geometry")
                                continue;

                            var value = feature.getProperties()[columnName];
                            var columnProperties = myDepositionPointTool._mapSgs.layerTree.layerInfo.dict_layer_info[idLayer].list_column.filter(obj => {
                                return obj.column_name === columnName
                            })[0];

                            // If value is a system date, format string
                            //if (new Date(value) != 'Invalid Date' && isNaN(value))
                            if (columnProperties) {
                                if (columnProperties.column_type == 'xsd:date-time')
                                    value = myDepositionPointTool._utility.TransformDateServerInDateTime(value);

                                objRow[columnName] = value;
                                if (columDefArrayExpandSize[columnName]) {
                                    if (value) {
                                        var valueSize = value.toString().length;
                                        columDefArrayExpandSize[columnName] = (valueSize > columDefArrayExpandSize[columnName]) ? valueSize : columDefArrayExpandSize[columnName];
                                    }
                                }
                                else {
                                    if (value)
                                        columDefArrayExpandSize[columnName] = value.toString().length;
                                    else
                                        columDefArrayExpandSize[columnName] = 30; // If fist empty
                                }
                                if (i === 0) {
                                    var columnSearchResult = myDepositionPointTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result;
                                    var visible = myDepositionPointTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).visible;
                                    var columnPrettyName = myDepositionPointTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).pretty_name;
                                    var searchResultOrder = myDepositionPointTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result_order;

                                    if (columnSearchResult) {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px',
                                            'search_order': searchResultOrder
                                        });
                                    } else {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false,
                                            'search_order': 0
                                        });
                                    }
                                    if (visible) {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px'
                                        });
                                    }
                                    else {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false
                                        });
                                    }
                                }
                            }
                        }
                        // Order columns by search order
                        columnDefArray = columnDefArray.sort((a, b) => (a.search_order > b.search_order) ? 1 : -1);

                        // Add primary key value
                        objRow["id_primary_key"] = idPrimaryKey;

                        // Add array row
                        columnValueArray.push(objRow);

                        // Put in feature highlight
                        myDepositionPointTool._mapSgs.featureToHighLight.push(feature);
                        var styleElement = myDepositionPointTool._mapSgs._defaultHighlighStyles;
                        myDepositionPointTool._mapSgs.featureToHighLight.getArray()[myDepositionPointTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                    }

                    // Add primary key to array
                    columnDefArray.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    columDefArrayExpand.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    // Add size to column in array expand
                    for (let i = 0; i < columDefArrayExpand.length; i++) {
                        var objDef = columDefArrayExpand[i];
                        if (objDef.width) {
                            if (columDefArrayExpandSize[objDef.data] > 50)
                                objDef.width = columDefArrayExpandSize[objDef.data].toString() + "px";
                            else
                                objDef.width = "50px";
                            columDefArrayExpand[i] = objDef;
                        }
                    };

                    // Show canvas search result
                    myDepositionPointTool._utility.ShowOpenCanvas3('offcanvas-search-result', true);

                    // Make datatable list
                    myDepositionPointTool._mapSgs.InitSearchResultTable(workspace, layerName, idLayer, featureHash, columnDefArray, columDefArrayExpand, columnValueArray, myDepositionPointTool.DetailElement);

                    // Go to Feature
                    myDepositionPointTool._mapSgs.map.getView().fit(myDepositionPointTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myDepositionPointTool._mapSgs.map.getSize() });

                    // Remove hide in offcanvas search result information
                    $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
                    $('#id-offcanvas-search-result-body').removeClass('ol-hidden');
                }
                else {
                    toastr["warning"]("Não foi encontrada, nenhuma camada");
                }
            };

            // Stop wait
            myDepositionPointTool._utility.ShowWait('offcanvas-map-spinner', false);
        });
    };

    /**
     * Refresh deposition layer
     */
    this._RefreshLayerDeposition = function()
    {
        // Refresh all route layer
        var arraylayerInfo = myDepositionPointTool._mapSgs.layerTree.FindAllLayerInfo(myDepositionPointTool._LayerDepositionName);
        for(var i = 0; i < arraylayerInfo.length; i++)
        {
            var layer = myDepositionPointTool._mapSgs._utility.GetLayerByName(myDepositionPointTool._mapSgs.map, arraylayerInfo[i].layerNameKey);
            layer.getSource().clear();
        }
    }

    // -- end private method --------------------------------------------------------------------

    // -- begin public method -------------------------------------------------------------------

    /**
     * Fill hash freguesia
     * @param {array} freguesiasData, array of freguesia
     */
    this.FillFreguesiaList = function (freguesiasData) {
        freguesiasData.forEach(x => {
            myDepositionPointTool._hashReference['freguesia_list'].push({ "id": x.IDFREGUESIA, "value": x.FREGUESIA });
        });

        myDepositionPointTool._utility.FillSelect('id-depositionPointToolFreguesia', myDepositionPointTool._hashReference['freguesia_list'], 'value', 'id', true);
    };

    /**
     * Build detail information for deposition point
     * @param {object} featureInfo, all information of the pub
     */
    this.DetailElement = function (featureInfo)
    {
        myDepositionPointTool._featureInfo = featureInfo;
        var hasButtonDelete = false;

        // If delete layer then delete button exist
        if (myDepositionPointTool._mapSgs._settings._mapSettings.operation_visible.DeleteLayers) {
            hasButtonDelete = true;
        }

        // If permission to edit then transform read on update
        if (myDepositionPointTool._mapSgs._settings._mapSettings.operation_visible.EditLayers)
        {
            if(featureInfo.mode === 'read')
                featureInfo.mode = 'update';
        }

        myDepositionPointTool._hashReference['equipamentos_list'] = [];
        myDepositionPointTool._hashReference['intervencoes_list'] = [];
        myDepositionPointTool._hashReference['observacoes_list'] = [];
        var codElement = "";

        // Start wait
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        // Clean Number of file
        $('.offcanvas-body-layer-detail-attachment-info-td span')[0].innerHTML = "-";

        // Define according to mode
        var readOnly = "readonly";
        var hiddenCol = false;
        switch (featureInfo.mode) {
            case 'update':
                // ajust button
                $('#id-offcanvas-body-layer-detail-button').removeClass('ol-hidden');
                if (hasButtonDelete) {
                    $('#id-save-feature-submit').removeClass('col-md-12');
                    $('#id-save-feature-submit').addClass('col-md-6');
                    $('#id-delete-feature-submit-zone').removeClass('ol-hidden');
                }
                else {
                    $('#id-save-feature-submit').removeClass('col-md-6');
                    $('#id-save-feature-submit').addClass('col-md-12');
                    $('#id-delete-feature-submit-zone').addClass('ol-hidden');
                }

                // Event save feature
                $('#id-save-feature-submit').off('click').on('click', function () {
                    myDepositionPointTool._SaveFeature(featureInfo.mode, featureInfo.fromMap);
                    myMapSgs._SaveFeature('delete', app.Select.getFeatures().getArray()[0]);
                });

                // Event delete feature
                $('#id-delete-feature-submit').off('click').on('click', function () {
                    var idDepositionPoint = featureInfo.feature.getProperties()[myDepositionPointTool._depositionPointIdColumnName];
                    myDepositionPointTool.DeleteDepositionPoint(idDepositionPoint);
                });

                readOnly = "";
                break;
            case 'create':
                // Ajust button
                $('#id-offcanvas-body-layer-detail-button').removeClass('ol-hidden');
                $('#id-save-feature-submit').removeClass('col-md-6');
                $('#id-save-feature-submit').addClass('col-md-12');
                $('#id-delete-feature-submit-zone').addClass('ol-hidden');

                // Event create feature
                $('#id-save-feature-submit').off('click').on('click', function () {
                    myDepositionPointTool._SaveFeature(featureInfo.mode, featureInfo.fromMap);
                });

                readOnly = "";
                break;
            default: // read
                $('#id-offcanvas-body-layer-detail-button').addClass('ol-hidden');
        }

        // Show canvas
        myDepositionPointTool._utility.ShowOpenCanvas3('id-offcanvas-layer-detail', true);

        // Layer info
        var layerObj = myDepositionPointTool._mapSgs.layerTree.layerInfo.dict_layer_info[featureInfo.idLayer];
        var layerName = layerObj.layer_info.layerName;
        var layerPrettyName = layerObj.layer_info.pretty_name;

        // Get codElement
        if (featureInfo.feature.getProperties().import_code)
            codElement = featureInfo.feature.getProperties().import_code;

        // Build title
        $('#id-offcanvas-head-title-element')[0].innerHTML = layerObj.layer_info.pretty_name;
        $('#id-offcanvas-head-code-element')[0].innerHTML = codElement;

        // -- Fields -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-detail-field').empty();

        var gpName = myDepositionPointTool._mapSgs.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy;

        layerObj.list_column.sort(myDepositionPointTool._Compare);

        var idDepositionPoint = -1;

        // Build Info field
        for (var i = 0; i < layerObj.list_column.length; i++)
        {
            var objColumn = layerObj.list_column[i];

            // Show only if field marked as visible
            if (!objColumn.visible) continue;            

            // Show only if field marked as editable for creations
            if (!objColumn.editable && featureInfo.mode == 'create') continue;

            if (objColumn.editable && (featureInfo.mode == 'update' || featureInfo.mode == 'create')) {
                readOnly = '';
                if (featureInfo.mode == 'update' && (objColumn.column_name == 'zone' || objColumn.column_name == 'id_zone')) {
                    readOnly = 'readonly'; // Cannot update zone in model (Update DB procedures to change this)
                }
            } else {
                readOnly = 'readonly';
            }

            // Change condition according to GP to not include ID fields (myTooltips._mapSgs.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy == 'GP_MEALHADA')
            //if (objColumn.column_name !== 'geom' && objColumn.column_name !== 'GEOMETRY ' && objColumn.column_name.substr(0, 2).toUpperCase() !== 'ID') {
            if ((objColumn.column_name !== 'geom' && objColumn.column_name !== 'GEOMETRY ' && objColumn.column_name.substr(0, 6).toUpperCase() === 'ID_REF')
                || (objColumn.column_name !== 'geom' && objColumn.column_name !== 'GEOMETRY ')) {

                let value = featureInfo.feature.getProperties()[objColumn.column_name];

                let isIdCol = false;
                let isRefCol = false;
                let codUniverseTable = "";

                switch (objColumn.column_name) {
                    case "IDPONTODEPOSICAO":
                        isIdCol = true;
                        idDepositionPoint = value;
                        break;
                    case "IDPONTODEPOSICAOSITUACAO":
                        isRefCol = true;
                        codUniverseTable = "situacao_list";
                        break;
                    case "IDTIPODEPOSICAO":
                        isRefCol = true;
                        codUniverseTable = "tipo_list";
                        // In create get id tipo deposicao
                        if(featureInfo.mode == 'create')
                        {
                            var layerInfoSelected = myDepositionPointTool._mapSgs.layerTree.layerInfo.dict_layer_info[myDepositionPointTool._mapSgs.layerTree.selectedLayer].layer_info;
                            if(layerInfoSelected.cqlFilter.indexOf("IDTIPODEPOSICAO") >= 0)
                            {
                                value = layerInfoSelected.cqlFilter.replace(/ /g, '').split("=")[1].replace(/'/g, '');
                            }
                        }
                        break;
                    case "IDPONTODEPOSICAOUTILIZACAO":
                        isRefCol = true;
                        codUniverseTable = "utilizacao_list";
                        break;
                    case "IDFREGUESIA":
                        isRefCol = true;
                        codUniverseTable = "freguesia_list";
                        if(featureInfo.mode != 'read')
                        {
                            var disabled = readOnly == 'readonly' ? 'disabled' : '';
                            var idComboNode = 'prop_assoc_' + objColumn.column_name;
                            // Add select box with associated entity possible values
                            $('#id-offcanvas-body-layer-detail-field').append($(
                                '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                                + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                                + '<select title="Nenhum escolhido" class="feature-field form-control ' + objColumn.column_type + '" id="' + idComboNode + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled + '><option></option></select>'
                                + '</div > '
                            ));

                            var coordinatesFeature = featureInfo.feature.getGeometry().getCoordinates();
                            if(typeof coordinatesFeature[0] === "object")
                                coordinatesFeature = coordinatesFeature[0];
                            myDepositionPointTool.GetFeatureBufferForCombo(coordinatesFeature[0],
                                                                           coordinatesFeature[1],
                                                                           myDepositionPointTool._radiusSearch,
                                                                           myDepositionPointTool._layerInformation.FREGUESIA.geoserver,
                                                                           myDepositionPointTool._layerInformation.FREGUESIA.workspace,
                                                                           myDepositionPointTool._layerInformation.FREGUESIA.layerName,
                                                                           myDepositionPointTool._layerInformation.FREGUESIA.geom_column_name,
                                                                           idComboNode,
                                                                           value);

                            // Event on change "Freguesia"
                            $('#' + idComboNode).off('change.bs.select').on('change.bs.select', function ()
                            {
                                var idFreguesia = $('#prop_assoc_IDFREGUESIA').val();
                                if(myDepositionPointTool._hashReferenceCombo["section"][idFreguesia])
                                {
                                    comboArray = myDepositionPointTool._hashReferenceCombo["section"][idFreguesia];
                                    myDepositionPointTool._utility.FillSelect('prop_assoc_IDFREGUESIATROCO', comboArray, 'value', 'id', true);
                                }
                            });

                            continue;
                        }
                        break;
                    case "IDFREGUESIATROCO":
                        isRefCol = true;
                        codUniverseTable = "";
                        var disabled = readOnly == 'readonly' ? 'disabled' : '';
                        var idComboNode = 'prop_assoc_' + objColumn.column_name;
                        // Add select box with associated entity possible values
                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<select title="Nenhum escolhido" class="feature-field form-control ' + objColumn.column_type + '" id="' + idComboNode + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled + '><option></option></select>'
                            + '</div > '
                        ));

                        var coordinatesFeature = featureInfo.feature.getGeometry().getCoordinates();
                        if(typeof coordinatesFeature[0] === "object")
                            coordinatesFeature = coordinatesFeature[0];
                        myDepositionPointTool.GetFeatureBufferForCombo(coordinatesFeature[0],
                                                                       coordinatesFeature[1],
                                                                       myDepositionPointTool._radiusSearch,
                                                                       myDepositionPointTool._layerInformation.VW_FREGUESIATROCO.geoserver,
                                                                       myDepositionPointTool._layerInformation.VW_FREGUESIATROCO.workspace,
                                                                       myDepositionPointTool._layerInformation.VW_FREGUESIATROCO.layerName,
                                                                       myDepositionPointTool._layerInformation.VW_FREGUESIATROCO.geom_column_name,
                                                                       idComboNode,
                                                                       value);

                        continue;
                        break;
                    case "IDENTIDADE":
                        isRefCol = true;
                        codUniverseTable = "entidades_list";
                        var disabled = readOnly == 'readonly' ? 'disabled' : '';
                        var idComboNode = 'prop_assoc_' + objColumn.column_name;
                        // Add select box with associated entity possible values
                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<div class="row" style="margin-left: 0px;">'
                            + '<select title="Nenhum escolhido" class="form-control js-example-basic-single offcanvas-body-select2-layer-detail" id="' + idComboNode + '" ' + disabled + '><option></option></select>'
                            + '</div>'
                            + '</div>'
                        ));

                        $('#' + idComboNode).select2(
                        {
                            ajax:
                            {
                                type: 'GET',
                                url: '/rest/app/DepositionPointTool/GetAllEntityBeginWith',
                                dataType: 'json',
                                delay: 250,
                                data: function (term) {
                                    return term;
                                },
                                processResults: function (data) {
                                    var listEntity = data.result;
                                    if (listEntity === null)
                                        return {
                                            "results": [],
                                            "pagination": {
                                                "more": false
                                            }
                                        }

                                    var resultArray = [];
                                    for (var i = 0; i < listEntity.length; i++) {
                                        var entityObj = listEntity[i];
                                        resultArray.push({
                                            "text": entityObj.entity,
                                            "id": entityObj.idEntity
                                        })
                                    }

                                    return {
                                        "results": resultArray,
                                        "pagination": {
                                            "more": false
                                        }
                                    }
                                }
                            },
                            minimumInputLength: 2,
                            language: "pt",
                            allowClear: true,
                            placeholder: "Escolha uma entidade"
                        });

                        if(value)
                        {
                            var data = {
                                "text": featureInfo.feature.getProperties()["ENTIDADE"],
                                "id": value
                            };
                            var newOption = new Option(data.text, data.id, true, true);
                            $('#' + idComboNode).append(newOption).trigger('change');
                        }
                        continue;
                        break;
                    case "COMPARTIMENTO":
                        var disabled = readOnly == 'readonly' ? 'disabled' : '';
                        var idComboNode = 'prop_assoc_' + objColumn.column_name;
                        // Add select box with associated entity possible values
                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<select title="Nenhum escolhido" class="feature-field form-control ' + objColumn.column_type + '" id="' + idComboNode + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled + '><option></option></select>'
                            + '</div > '
                        ));

                        if($('#prop_assoc_IDTIPODEPOSICAO').val() === myDepositionPointTool._idTypeDepositionCompartimento) // TODO - Sem tempo alterar isto depois para ecoponto
                        {
                            var idCompartimento = featureInfo.feature.getProperties()["IDPONTODEPOSICAOUTILIZACAO"];
                            comboArray = myDepositionPointTool._hashReference["utilizacao_list"];
                            myDepositionPointTool._utility.FillSelect(idComboNode, comboArray, 'value', 'id');
                            $('#' + idComboNode).selectpicker('val', idCompartimento);
                        }
                        else
                        {
                            var idCompartimento = featureInfo.feature.getProperties()["IDPONTODEPOSTIPOCOMPARTIMENTO"];
                            comboArray = myDepositionPointTool._hashReference["tipo_compartimento_list"];
                            myDepositionPointTool._utility.FillSelect(idComboNode, comboArray, 'value', 'id');
                            $('#' + idComboNode).selectpicker('val', idCompartimento);
                        }
                        continue;
                        break;
                    default:
                        break;
                };

                if (isIdCol) {
                    hiddenCol = true;
                } else if (gpName == 'GP_PONTA_DELGADA' && objColumn.column_name == 'DATA') {
                    hiddenCol = true; // Hide column DATA for PONTA DELGADA creations
                    value = myDepositionPointTool._utility.getNewDateForServer();
                } else {
                    hiddenCol = false;
                }

                if (value === null || value === undefined)
                    value = '';

                // Act according column type
                switch (objColumn.column_type) {
                    case "xsd:date-time":
                        value = myDepositionPointTool._utility.TransformDateServerInDateII(value);
                        break;
                    default:
                    // do nothing
                }

                var comboArray = [];
                var prefix = "id_";
                if (isRefCol) {
                    comboArray = myDepositionPointTool._hashReference[codUniverseTable];
                    prefix = "";
                }

                // Check if there is an associated field with a id_ prefix to add combo boxes
                if (isRefCol)
                {
                    var defValue = "";

                    if (value != "") {
                        if (typeof comboArray == "undefined" && objColumn.column_name === "IDFREGUESIATROCO") {
                            comboArray = myDepositionPointTool._hashReference["trocos_list"];
                        }

                        if (comboArray.length > 0) {
                            if (objColumn.column_name === "IDFREGUESIATROCO") {
                                let freguesiaTroco = myDepositionPointTool._hashReference["freguesia_troco_list"].filter(function (el) {
                                    return el.id == value;
                                });

                                if (freguesiaTroco.length > 0) {
                                    let idTroco = freguesiaTroco[0].idTroco;

                                    let troco = myDepositionPointTool._hashReference["trocos_list"].filter(function (el) {
                                        return el.id == idTroco;
                                    });

                                    if (troco.length > 0) {
                                        defValue = troco[0];
                                    }
                                }
                            } else if (objColumn.column_name == "FREGUESIA") {
                                defValue = comboArray.filter(function (ob) { return ob.value == value.toUpperCase(); })[0]
                            } else {
                                defValue = comboArray.filter(function (ob) { return ob.id == value; })[0]
                            }

                            if (featureInfo.mode == 'read') {
                                defValue = defValue.value;
                            } else {
                                defValue = defValue.id;
                            }
                        }
                    }

                    switch (objColumn.column_name) {
                        case "FREGUESIA":
                            var featureFreguesia = myDepositionPointTool._GetFreguesiaInfoFromPoint(myDepositionPointTool._featureInfo.feature);
                            if (featureFreguesia !== null)
                                defValue = featureFreguesia.getProperties().IDFREGUESIA;
                            break;
                        default:
                            break;
                    }

                    // In read mode, add text box for ID_REF
                    if (featureInfo.mode == 'read') {

                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<input class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + prefix + objColumn.column_name + '" type="text" id="prop_' + prefix + objColumn.column_name + '" value="' + defValue + '" ' + readOnly + '/>'
                            + '</div > '
                        ));

                    } else {

                        var disabled = readOnly == 'readonly' ? 'disabled' : '';
                        // Add select box with associated entity possible values
                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<select title="Nenhum escolhido" class="feature-field form-control ' + objColumn.column_type + '" id="prop_assoc_' + objColumn.column_name + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled + '><option></option></select>'
                            + '</div > '
                        ));

                        myDepositionPointTool._utility.FillSelect("prop_assoc_" + objColumn.column_name, comboArray, 'value', 'id');

                        $('#' + 'prop_assoc_' + objColumn.column_name).selectpicker('val', defValue);

                        // Add field that contains ID for associated entity
                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row hidden">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<input class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + prefix + objColumn.column_name + '" type="text" id="prop_' + prefix + objColumn.column_name + '" value="' + defValue + '" ' + readOnly + '/>'
                            + '</div > '
                        ));

                        if(objColumn.column_name === "IDTIPODEPOSICAO")
                        {
                            var idComboNode = 'prop_assoc_' + objColumn.column_name;
                            $('#' + idComboNode).off('change.bs.select').on('change.bs.select', function()
                            {
                                if($('#' + this.id).val() === myDepositionPointTool._idTypeDepositionCompartimento) // TODO - Sem tempo alterar isto depois para ecoponto
                                {
                                    var comboArrayList = myDepositionPointTool._hashReference["utilizacao_list"];
                                    myDepositionPointTool._utility.FillSelect('prop_assoc_COMPARTIMENTO', comboArrayList, 'value', 'id');
                                }
                                else
                                {
                                    var comboArrayList = myDepositionPointTool._hashReference["tipo_compartimento_list"];
                                    myDepositionPointTool._utility.FillSelect("prop_assoc_COMPARTIMENTO", comboArrayList, 'value', 'id');
                                }
                            });
                        }
                    }
                } else {
                    $('#id-offcanvas-body-layer-detail-field').append($(
                        '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                        + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                        + '<input class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="text" id="prop_' + objColumn.column_name + '" value="' + value + '" ' + readOnly + '/>'
                        + '</div > '
                    ));
                }
            }
        };

        if(featureInfo.mode !== 'create')
        {
            let container = $('#id-offcanvas-layer-detail .offcanvas-body-layer-detail.content-layer-detail > div.col-md-12'); //$("#mCSB_8_container");

            // -- Equipamentos -------------------------------------------------------------------------------
            $('#id-offcanvas-body-layer-equipamentos').remove();
            myDepositionPointTool._equipamentosRowCounter = 0;
            //var buttonEquipamento = (featureInfo.mode !== 'read')?'<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-equipamentos-btn-add-equipamento" style="margin-bottom: 5px;">Novo Equipamento</button>':'';
            var buttonEquipamento = '<a id="id-offcanvas-body-layer-detail-equipamentos-btn-add-equipamento" class="offcanvas-body-layer-deposition-point-new-element-btn" title="Novo Equipamento" id-deposition-point="' + idDepositionPoint + '"><i class="fa fa-plus-square"></i></a>';

            let equipamentosContent = '<div id="id-offcanvas-body-layer-detail-equipamentos" class="offcanvas-block" style="display: none;">'
                + buttonEquipamento
                + '<div class="table-responsive">'
                + '<div id="id-equipamentos-table-container" class="body table-responsive">'
                + '<table id="id-equipamentos-table" class="table table-striped table-bordered table-hover table-deposition-point" width="100%"></table>'
                + '</div>'
                + '</div>'
                + '</div>';

            container.append('<div id="id-offcanvas-body-layer-equipamentos" class="row margin-top-lg offcanvas-body-layer-detail">'
                + '<div class="col-md-12">'
                + '<div>'
                + '<div target-id="id-offcanvas-body-layer-detail-equipamentos" class="offcanvas-collapse">'
                + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
                + '<label>Equipamentos</label>'
                + '</div>'
                + equipamentosContent
                + '</div>'
                + '<div class="offcanvas-separator"></div>'
                + '</div>'
                + '</div>');

            // Destroy if exists
            if (myDepositionPointTool._equipmentDpDatatable != null) {

                // Destroy table
                myDepositionPointTool._equipmentDpDatatable.destroy();
            }

            // Build equipment deposition point table
            myDepositionPointTool._equipmentDpDatatable = $('#id-equipamentos-table').DataTable({
                "dom": '<rtip',
                "destroy": true,
                "language": {
                    "emptyTable": 'Nenhum elemento'
                },
                "fixedHeader": true,
                "info": false,
                "scrollCollapse": false,
                "deferRender": false,
                "scroller": false,
                "paging": false,
                "ordering": false,
                "columns": myDepositionPointTool._hashColumDefinition.column_equipment_dp_definition,
                "select": false,
                "name": "equipment_table",
                "rowId": 'idEquipamento',
                "initComplete": function(settings, json)
                {
                    $.ajax({
                        type: 'GET',
                        url: '/rest/app/DepositionPointTool/GetEquipmentOfDepositionPoint?idDepositionPoint=' + featureInfo.feature.getProperties().IDPONTODEPOSICAO,
                        async: true,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na obtenção do equipamento");
                            }
                            else {
                                switch (data.result.status) {
                                    case 'SUCCESS':
                                        var listEquipment = data.result.listEquipment;
                                        if (listEquipment.length > 0) {
                                            for (let i = 0; i < listEquipment.length; i++) {
                                                var equipment = listEquipment[i];
                                                myDepositionPointTool._equipmentDpDatatable.row.add({
                                                    idEquipamento: equipment.idEquipamento,
                                                    equipamento: equipment.equipamento,
                                                    idTipoEquipamento: equipment.idTipoEquipamento,
                                                    tipoEquipamento: equipment.tipoEquipamento,
                                                    tipoFluxo: equipment.tipoFluxo,
                                                    tipoCapacidadeContentor: equipment.tipoCapacidadeContentor,
                                                    quantidade: equipment.quantidade
                                                });
                                            }
                                            myDepositionPointTool._equipmentDpDatatable.draw();
                                        }
                                        break;
                                    case 'ERROR':
                                        toastr["error"]("Erro na obtenção do equipamento");
                                        break;
                                    default:
                                }
                            }

                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro na obtenção do equipamento");
                        }
                    });
                }
            });

            // Event on draw table
            myDepositionPointTool._equipmentDpDatatable.on('draw', function () {
            
                // Open detail equipment
                $('.button-detail-equipment').off('click').on('click', function () {
                    var idEquipment= this.parentElement.parentElement.id;

                    myDepositionPointTool._GetEquipmentDetail(idEquipment);
                });
        
                // Open remove equipment from deposition point
                $('.button-remove-equipment').off('click').on('click', function () {
                    var idEquipment = this.parentElement.parentElement.id;

                    $('#id-modal-deposition-point-tool-delete-confirm-btn').attr("id-element", idEquipment);
                    $('#id-modal-deposition-point-tool-delete-confirm-btn').attr("element-type", 'equipment');
                    $('#id-modal-deposition-point-tool-delete-confirm-header-title').html("Tem a certeza que pretende remover este equipamento?");
                    $('#id-modal-deposition-point-tool-delete-confirm').show();
                });

                // Increase quantity of a equipment
                $('.button-increase-equipment-quantity').off('click').on('click', function () {
                    var idEquipment= this.parentElement.parentElement.parentElement.id;
                    var value = myDepositionPointTool._equipmentDpDatatable.cell('#' + idEquipment, 8).data();
                    var newValue = value + 1;

                    myDepositionPointTool._equipmentDpDatatable.cell('#' + idEquipment, 8).data(newValue).draw();
                    myDepositionPointTool._ChangeEquipmentQuantity(idEquipment, newValue, value);
                });

                // Decrease quantity of a equipment
                $('.button-decrease-equipment-quantity').off('click').on('click', function () {
                    var idEquipment= this.parentElement.parentElement.parentElement.id;
                    var value = myDepositionPointTool._equipmentDpDatatable.cell('#' + idEquipment, 8).data();
                    var newValue = value - 1;

                    // Prevent 0 or below
                    if (newValue < 1)
                    {
                        toastr["warning"]("Não é permitido valores abaixo de 1");
                        return;
                    }

                    myDepositionPointTool._equipmentDpDatatable.cell('#' + idEquipment, 8).data(newValue).draw();
                    myDepositionPointTool._ChangeEquipmentQuantity(idEquipment, newValue, value);
                });
            });

            // New equipment type add
            $('#id-offcanvas-body-layer-detail-equipamentos-btn-add-equipamento').off('click').on('click', function () {
                $('#id-modal-deposition-point-tool-equipment-save').attr('mode', 'save');
                $('#id-modal-deposition-point-tool-equipment-save i')[0].setAttribute("class", "fa fa-save");
                $('#id-modal-deposition-point-tool-equipment').show();
            });

            // -- Producer ------------------------------------------------------------------------
            $('#id-offcanvas-body-layer-produtores').remove();
            myDepositionPointTool._producerRowCounter = 0;
            var buttonInter = '<a id="id-offcanvas-body-layer-detail-producer-btn-add-producer" class="offcanvas-body-layer-deposition-point-new-element-btn" title="Novo Produtor" id-deposition-point="' + idDepositionPoint + '"><i class="fa fa-plus-square"></i></a>';

            let produtoresContent = '<div id="id-offcanvas-body-layer-detail-produtores" class="offcanvas-block" style="display: none;">'
                + buttonInter
                + '<div class="table-responsive">'
                + '<div id="id-producer-table-container" class="body table-responsive">'
                + '<table id="id-producer-table" class="table table-striped table-bordered table-hover table-deposition-point" width="100%"></table>'
                + '</div>'
                + '</div>'
                + '</div>';

            container.append('<div id="id-offcanvas-body-layer-produtores" class="row margin-top-lg offcanvas-body-layer-detail">'
                + '<div class="col-md-12">'
                + '<div>'
                + '<div target-id="id-offcanvas-body-layer-detail-produtores" class="offcanvas-collapse">'
                + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
                + '<label>Produtores</label>'
                + '</div>'
                + produtoresContent
                + '</div>'
                + '<div class="offcanvas-separator"></div>'
                + '</div>'
                + '</div>');

            // Destroy if exists
            if (myDepositionPointTool._producerDatatable != null) {

                // Destroy table
                myDepositionPointTool._producerDatatable.destroy();
            }

            // Build equipment intervation deposition point table
            myDepositionPointTool._producerDatatable = $('#id-producer-table').DataTable({
                "dom": '<rtip',
                "destroy": true,
                "language": {
                    "emptyTable": 'Nenhum elemento'
                },
                "fixedHeader": true,
                "info": false,
                "scrollCollapse": false,
                "deferRender": false,
                "scroller": false,
                "paging": false,
                "ordering": false,
                "columns": myDepositionPointTool._hashColumDefinition.column_producer_definition,
                "select": false,
                "name": "producer_table",
                "rowId": 'idProdutor',
                "initComplete": function(settings, json)
                {
                    $.ajax({
                        type: 'GET',
                        url: '/rest/app/DepositionPointTool/GetAllProducerFromDepositionPoint?idDepositionPoint=' + featureInfo.feature.getProperties().IDPONTODEPOSICAO,
                        async: true,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na obtenção dos produtores");
                            }
                            else {
                                switch (data.result.status) {
                                    case 'SUCCESS':
                                        var listProducer = data.result.listProducer;
                                        if (listProducer.length > 0) {
                                            for (let i = 0; i < listProducer.length; i++) {
                                                var producer = listProducer[i];
                                                myDepositionPointTool._producerDatatable.row.add({
                                                    idProdutor: producer.idProdutor,
                                                    idEntidade: producer.idEntidade,
                                                    entidade: producer.entidade,
                                                    idTipoCliente: producer.idTipoCliente,
                                                    tipoCliente: producer.tipoCliente,
                                                    fraccao: producer.fraccao,
                                                    idPontoDeposicao: producer.idPontoDeposicao
                                                });
                                            }
                                            myDepositionPointTool._producerDatatable.draw();
                                        }
                                        break;
                                    case 'ERROR':
                                        toastr["error"]("Erro na obtenção dos produtores");
                                        break;
                                    default:
                                }
                            }
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro na obtenção dos produtores");
                        }
                    });
                }
            });

            // Event on draw table
            myDepositionPointTool._producerDatatable.on('draw', function ()
            {
                // Open detail producer
                $('.button-detail-deposition-point-producer').off('click').on('click', function ()
                {
                    var idProducer = this.parentElement.parentElement.id;

                    myDepositionPointTool._GetProducerDetail(idProducer);
                });

                // Open remove producer from deposition point
                $('.button-remove-deposition-point-producer').off('click').on('click', function ()
                {
                    var idProducer = this.parentElement.parentElement.id;

                    $('#id-modal-deposition-point-tool-delete-confirm-btn').attr("id-element", idProducer);
                    $('#id-modal-deposition-point-tool-delete-confirm-btn').attr("element-type", 'producer');
                    $('#id-modal-deposition-point-tool-delete-confirm-header-title').html("Tem a certeza que pretende remover este produtor?");
                    $('#id-modal-deposition-point-tool-delete-confirm').show();
                });
            });

            // New equipment producer add
            $('#id-offcanvas-body-layer-detail-producer-btn-add-producer').off('click').on('click', function ()
            {
                //Set mode
                $('#id-modal-deposition-point-tool-producer-save').attr('mode', 'create');

                // Clean modal producer detail
                $('#id-deposition-point-producer-detail-entity').val('').trigger('change');
                $('#id-modal-deposition-point-tool-producer-body-form input').val('');

                // Set id deposition point
                $('#id-modal-deposition-point-tool-producer-body-id-deposition-point').val($('#id-offcanvas-body-layer-detail-producer-btn-add-producer').attr('id-deposition-point'));

                // Open Modal
                $('#id-modal-deposition-point-tool-producer').show();
            });


            // -- Intervention ------------------------------------------------------------------------
            $('#id-offcanvas-body-layer-intervencoes').remove();
            myDepositionPointTool._intervencoesRowCounter = 0;
            //var buttonInter = (featureInfo.mode !== 'read')?'<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-intervencoes-btn-add-intervencao" style="margin-bottom: 5px;">Inserir Intervenção</button>':'';
            var buttonInter = '<a id="id-offcanvas-body-layer-detail-intervencoes-btn-add-intervencao" class="offcanvas-body-layer-deposition-point-new-element-btn" title="Nova Intervenção" id-deposition-point="' + idDepositionPoint + '"><i class="fa fa-plus-square"></i></a>';

            let intervencoesContent = '<div id="id-offcanvas-body-layer-detail-intervencoes" class="offcanvas-block" style="display: none;">'
                + buttonInter
                + '<div class="table-responsive">'
                + '<div id="id-equipment-intervention-table-container" class="body table-responsive">'
                + '<table id="id-equipment-intervention-table" class="table table-striped table-bordered table-hover table-deposition-point" width="100%"></table>'
                + '</div>'
                + '</div>'
                + '</div>';

            container.append('<div id="id-offcanvas-body-layer-intervencoes" class="row margin-top-lg offcanvas-body-layer-detail">'
                + '<div class="col-md-12">'
                + '<div>'
                + '<div target-id="id-offcanvas-body-layer-detail-intervencoes" class="offcanvas-collapse">'
                + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
                + '<label>Intervenções</label>'
                + '</div>'
                + intervencoesContent
                + '</div>'
                + '<div class="offcanvas-separator"></div>'
                + '</div>'
                + '</div>');

            // Destroy if exists
            if (myDepositionPointTool._equipmentInterventionDatatable != null) {

                // Destroy table
                myDepositionPointTool._equipmentInterventionDatatable.destroy();
            }

            // Build equipment intervation deposition point table
            myDepositionPointTool._equipmentInterventionDatatable = $('#id-equipment-intervention-table').DataTable({
                "dom": '<rtip',
                "destroy": true,
                "language": {
                    "emptyTable": 'Nenhum elemento'
                },
                "fixedHeader": true,
                "info": false,
                "scrollCollapse": false,
                "deferRender": false,
                "scroller": false,
                "paging": false,
                "ordering": false,
                "columns": myDepositionPointTool._hashColumDefinition.column_equipment_intervention_definition,
                "select": false,
                "name": "equipment_intervention_table",
                "rowId": 'idEquipamentoIntervencao',
                "initComplete": function(settings, json)
                {
                    $.ajax({
                        type: 'GET',
                        url: '/rest/app/DepositionPointTool/GetEquipmentIntervention?idDepositionPoint=' + featureInfo.feature.getProperties().IDPONTODEPOSICAO,
                        async: true,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na obtenção das intervenções");
                            }
                            else {
                                switch (data.result.status) {
                                    case 'SUCCESS':
                                        var listEquipmentIntervention = data.result.listEquipmentIntervention;
                                        if (listEquipmentIntervention.length > 0) {
                                            for (let i = 0; i < listEquipmentIntervention.length; i++) {
                                                var equipmentIntervention = listEquipmentIntervention[i];
                                                myDepositionPointTool._equipmentInterventionDatatable.row.add({
                                                    idEquipamentoIntervencao: equipmentIntervention.idEquipamentoIntervencao,
                                                    equipamentoIntervencao: equipmentIntervention.equipamentoIntervencao,
                                                    idTipoIntervencao: equipmentIntervention.idTipoIntervencao,
                                                    tipoIntervencao: equipmentIntervention.tipoIntervencao,
                                                    dataIntervencao: myDepositionPointTool._utility.TransformDateServerInDateII(equipmentIntervention.dataIntervencao)
                                                });
                                            }
                                            myDepositionPointTool._equipmentInterventionDatatable.draw();
                                        }
                                        break;
                                    case 'ERROR':
                                        toastr["error"]("Erro na obtenção das intervenções");
                                        break;
                                    default:
                                }
                            }
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro na obtenção das intervenções");
                        }
                    });
                }
            });

            // Event on draw table
            myDepositionPointTool._equipmentInterventionDatatable.on('draw', function () {
            
                // Open detail equipment intervention
                $('.button-detail-equipment-intervention').off('click').on('click', function ()
                {
                    var idEquipmentIntervencao = this.parentElement.parentElement.id;

                    myDepositionPointTool._GetEquipmentInterventionDetail(idEquipmentIntervencao);
                });

                // Open remove equipment intervention from deposition point
                $('.button-remove-equipment-intervention').off('click').on('click', function ()
                {
                    var idEquipmentIntervencao = this.parentElement.parentElement.id;

                    $('#id-modal-deposition-point-tool-delete-confirm-btn').attr("id-element", idEquipmentIntervencao);
                    $('#id-modal-deposition-point-tool-delete-confirm-btn').attr("element-type", 'equipment-intervention');
                    $('#id-modal-deposition-point-tool-delete-confirm-header-title').html("Tem a certeza que pretende remover esta intervenção?");
                    $('#id-modal-deposition-point-tool-delete-confirm').show();
                });
            });

            // New equipment intervention add
            $('#id-offcanvas-body-layer-detail-intervencoes-btn-add-intervencao').off('click').on('click', function ()
            {
                //Set mode
                $('#id-modal-deposition-point-tool-equipment-intervention-save').attr('mode', 'create');

                // Clean modal equipment detail
                $('#id-modal-deposition-point-tool-equipment-intervention-body-form input').val('');
                $('#id-modal-deposition-point-tool-equipment-intervention-body-form textarea').val('');
                $('#id-modal-deposition-point-tool-equipment-intervention-body-type-intervention').val('').change();

                // Set id deposition point
                $('#id-modal-deposition-point-tool-equipment-intervention-body-id-deposition-point').val($('#id-offcanvas-body-layer-detail-intervencoes-btn-add-intervencao').attr('id-deposition-point'));

                // Open Modal
                $('#id-modal-deposition-point-tool-equipment-intervention').show();
            });

            // -- Observações -------------------------------------------------------------------------------
            $('#id-offcanvas-body-layer-observacoes').remove();
            myDepositionPointTool._observacoesRowCounter = 0;
            //var buttonObs = (featureInfo.mode !== 'read')?'<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-observacoes-btn-add-observacao" style="margin-bottom: 5px;">Inserir Observação</button>':'';
            var buttonObs = '<a id="id-offcanvas-body-layer-detail-observacoes-btn-add-observacao" class="offcanvas-body-layer-deposition-point-new-element-btn" title="Nova Observação" id-deposition-point="' + idDepositionPoint + '"><i class="fa fa-plus-square"></i></a>';

            let observacoesContent = '<div id="id-offcanvas-body-layer-detail-observacoes" class="offcanvas-block" style="display: none;">'
                + buttonObs
                + '<div class="table-responsive">'
                + '<div id="id-equipment-observation-table-container" class="body table-responsive">'
                + '<table id="id-equipment-observation-table" class="table table-striped table-bordered table-hover table-deposition-point" width="100%"></table>'
                + '</div>'
                + '</div>'
                + '</div>';

            container.append('<div id="id-offcanvas-body-layer-observacoes" class="row margin-top-lg offcanvas-body-layer-detail">'
                + '<div class="col-md-12">'
                + '<div>'
                + '<div target-id="id-offcanvas-body-layer-detail-observacoes" class="offcanvas-collapse">'
                + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
                + '<label>Observações</label>'
                + '</div>'
                + observacoesContent
                + '</div>'
                + '<div class="offcanvas-separator"></div>'
                + '</div>'
                + '</div>');

            // Destroy if exists
            if (myDepositionPointTool._depositionPointObservationDatatable != null) {

                // Destroy table
                myDepositionPointTool._depositionPointObservationDatatable.destroy();
            }

            // Build equipment intervation deposition point table
            myDepositionPointTool._depositionPointObservationDatatable = $('#id-equipment-observation-table').DataTable({
                "dom": '<rtip',
                "destroy": true,
                "language": {
                    "emptyTable": 'Nenhum elemento'
                },
                "fixedHeader": true,
                "info": false,
                "scrollCollapse": false,
                "deferRender": false,
                "scroller": false,
                "paging": false,
                "ordering": false,
                "columns": myDepositionPointTool._hashColumDefinition.column_deposition_point_observation_definition,
                "select": false,
                "name": "deposition_point_observation_table",
                "rowId": 'idPontoDeposicaoObservacao',
                "initComplete": function(settings, json)
                {
                    $.ajax({
                        type: 'GET',
                        url: '/rest/app/DepositionPointTool/GetDepositionPointObservation?idDepositionPoint=' + featureInfo.feature.getProperties().IDPONTODEPOSICAO,
                        async: true,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na obtenção das observações");
                            }
                            else {
                                switch (data.result.status) {
                                    case 'SUCCESS':
                                        var listObservation = data.result.listObservation;
                                        if (listObservation.length > 0) {
                                            for (let i = 0; i < listObservation.length; i++) {
                                                var observation = listObservation[i];
                                                myDepositionPointTool._depositionPointObservationDatatable.row.add({
                                                    idPontoDeposicaoObservacao: observation.idPontoDeposicaoObservacao,
                                                    pontoDeposicaoObservacao: observation.pontoDeposicaoObservacao,
                                                    data: myDepositionPointTool._utility.TransformDateServerInDateII(observation.data),
                                                    idPontoDeposicao: observation.idPontoDeposicao
                                                });
                                            }
                                            myDepositionPointTool._depositionPointObservationDatatable.draw();
                                        }
                                        break;
                                    case 'ERROR':
                                        toastr["error"]("Erro na obtenção das observações");
                                        break;
                                    default:
                                }
                            }
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro na obtenção das observações");
                        }
                    });
                }
            });

            // Event on draw table
            myDepositionPointTool._depositionPointObservationDatatable.on('draw', function () {
            
                // Open detail equipment intervention
                $('.button-detail-deposition-point-observation').off('click').on('click', function ()
                {
                    var idDepositionPointObservation = this.parentElement.parentElement.id;

                    myDepositionPointTool._GetDepositionPointObservation(idDepositionPointObservation);
                });

                // Open remove observaton from deposition point
                $('.button-remove-deposition-point-observation').off('click').on('click', function ()
                {
                    var idDepositionPointObservation = this.parentElement.parentElement.id;

                    $('#id-modal-deposition-point-tool-delete-confirm-btn').attr("id-element", idDepositionPointObservation);
                    $('#id-modal-deposition-point-tool-delete-confirm-btn').attr("element-type", 'observation');
                    $('#id-modal-deposition-point-tool-delete-confirm-header-title').html("Tem a certeza que pretende remover a observação?");
                    $('#id-modal-deposition-point-tool-delete-confirm').show();
                });
            });

            // New deposition point observation
            $('#id-offcanvas-body-layer-detail-observacoes-btn-add-observacao').off('click').on('click', function ()
            {
                //Set mode
                $('#id-modal-deposition-point-tool-observation-save').attr('mode', 'create');

                // Clean modal equipment detail
                $('#id-modal-deposition-point-tool-observation-body-form input').val('');
                $('#id-modal-deposition-point-tool-observation-body-form textarea').val('');

                // Set id deposition point
                $('#id-modal-deposition-point-tool-observation-body-id-deposition-point').val($('#id-offcanvas-body-layer-detail-intervencoes-btn-add-intervencao').attr('id-deposition-point'));

                // Open Modal
                $('#id-modal-deposition-point-tool-observation').show();
            });
        }

        // -- Add values and behaviours to combo boxes --
        $('select.feature-field').each(function () {
            var comboBox = $(this);
            var destinationText = comboBox.data('destination-field');
            comboBox.on('change', function () {
                // Update respective id field for db update
                $('#' + destinationText).val($(this).val());
            });
        });

        // -- Refresh collapse elements --
        $('.offcanvas-collapse').off('click').on('click', function () {
            var idNodeToCollapse = this.getAttribute('target-id');
            $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
            // Close all other info

            $('#' + idNodeToCollapse).toggle('ol-hidden');
        });

        // -- File --------------------------------------------------------------------------------

        // Init Upload for entity
        if (myDepositionPointTool._mapSgs._uploadAttachtment)
            myDepositionPointTool._mapSgs._uploadAttachtment.LoadAttachment(featureInfo.id, layerName, 'id-offcanvas-body-layer-detail-attachment-zone', 'id-offcanvas-body-layer-detail-attachment-form', 'id-offcanvas-body-layer-detail-attachment-add', 'offcanvas-body-layer-detail-attachment-info-td', 'id-offcanvas-body-layer-detail-attachment-spinner');

        $('#prop_assoc_FREGUESIA').on('changed.bs.select', function () {
            $("#prop_assoc_IDFREGUESIATROCO").empty();

            let selectedValue = this.value;

            let freguesiaTrocoList = myDepositionPointTool._hashReference['freguesia_troco_list'];

            let filteredFreguesiaTroco = freguesiaTrocoList.filter(function (el) {
                return el.idFreguesia === selectedValue;
            });

            //let idTrocos = filteredFreguesiaTroco.map(x => x.idTroco);

            let trocosList = myDepositionPointTool._hashReference['trocos_list'];

            let filteredTrocos = [];

            filteredFreguesiaTroco.forEach(x => {
                let troco = trocosList.filter(function (el) {
                    return el.id === x.idTroco;
                });

                if (troco.length > 0)
                    filteredTrocos.push({ "id": x.id, "value": troco[0].value });
            });

            myDepositionPointTool._utility.FillSelect("prop_assoc_IDFREGUESIATROCO", filteredTrocos, 'value', 'id');
        });

        // Stop wait
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
    };

    /**
     * Clean detail  
     */
    this.CleanDetail = function ()
    {
        // -- Equipamentos ------------------------------------------------------------------------

        // Destroy if exists
        if (myDepositionPointTool._equipmentDpDatatable != null) {

            // Destroy table
            myDepositionPointTool._equipmentDpDatatable.destroy();
        }
        $('#id-offcanvas-body-layer-equipamentos').remove();

        // -- Produtores --------------------------------------------------------------------------

        // Destroy if exists
        if (myDepositionPointTool._producerDatatable != null) {

            // Destroy table
            myDepositionPointTool._producerDatatable.destroy();
        }
        $('#id-offcanvas-body-layer-produtores').remove();

        // -- Intervenções ------------------------------------------------------------------------

        // Destroy if exists
        if (myDepositionPointTool._equipmentInterventionDatatable != null) {

            // Destroy table
            myDepositionPointTool._equipmentInterventionDatatable.destroy();
        }
        $('#id-offcanvas-body-layer-intervencoes').remove();

        // -- Observações -------------------------------------------------------------------------

        // Destroy if exists
        if (myDepositionPointTool._depositionPointObservationDatatable != null) {

            // Destroy table
            myDepositionPointTool._depositionPointObservationDatatable.destroy();
        }
        $('#id-offcanvas-body-layer-observacoes').remove();
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Change value of quantity of equipment
     * @param {int} idEquipment, equipment identifier
     * @param {int} newValue, new value
     * @param {int} oldValue, old value
     */
    this._ChangeEquipmentQuantity = function(idEquipment, newValue, oldValue)
    {
        $.ajax({
            type: 'GET',
            url: '/rest/app/DepositionPointTool/GetChangeValueQuantity?idEquipment=' + idEquipment + '&newValue=' + newValue,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na alteração do valor da quantidade do equipamento");
                    myDepositionPointTool._equipmentDpDatatable.cell('#' + idEquipment, 8).data(oldValue).draw();
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na alteração do valor da quantidade do equipamento");
                            myDepositionPointTool._equipmentDpDatatable.cell('#' + idEquipment, 8).data(oldValue).draw();
                            break;
                        default:
                    }
                }

            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção do equipamento");
                myDepositionPointTool._equipmentDpDatatable.cell('#' + idEquipment, 8).data(oldValue).draw();
            }
        });
    };

    /**
     * Get equipment detail
     * @param {int} idEquipment, equipment identifier
     */
    this._GetEquipmentDetail = function(idEquipment)
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        // Clean modal equipment detail
        $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input').val('');
        $('#id-modal-deposition-point-tool-equipment-in-dp-body-form textarea').val('');

        $.ajax({
            type: 'GET',
            url: '/rest/app/DepositionPointTool/GetEquipmentDetail?idEquipment=' + idEquipment,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da informação do equipamento");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var equipment = data.result.equipment;

                            // Define title
                            $('#id-modal-deposition-point-tool-equipment-in-dp-title').html("Equipamento - " + equipment.equipamento);

                            // Fill equipment detail
                            $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="IdEquipamento"]').val(equipment.idequipamento);
                            $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="Equipamento"]').val(equipment.equipamento);
                            $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="IdTipoEquipamento"]').val(equipment.idtipoequipamento);
                            $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="TipoEquipamento"]').val(equipment.tipoequipamento);
                            $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="TipoFluxo"]').val(equipment.tipofluxo);
                            $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="TipoCapacidadeContentor"]').val(equipment.tipocapacidadecontentor);
                            $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="Quantidade"]').val(equipment.quantidade);
                            $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="DataRecepcao"]').val(myDepositionPointTool._utility.TransformDateServerInDateII(equipment.datarecepcao));
                            $('#id-modal-deposition-point-tool-equipment-in-dp-body-form textarea[name="Descricao"]').val(equipment.descricao);
                            $('#id-modal-deposition-point-tool-equipment-in-dp-body-form textarea[name="Observacao"]').val(equipment.observacao);

                            // Init attachment for equipment
                            myDepositionPointTool._mapSgs._uploadAttachtment.LoadAttachment(equipment.idequipamento, 'equipment', 'id-offcanvas-body-dp-equipament-attachment-zone', 'id-offcanvas-body-dp-equipament-attachment-form', 'id-offcanvas-body-dp-equipament-attachment-add', 'offcanvas-body-dp-equipament-attachment-info-td', 'id-offcanvas-body-dp-equipament-attachment-spinner');

                            // Show modal
                            $('#id-modal-deposition-point-tool-equipment-in-dp').show();
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na obtenção da informação do equipamento");
                            break;
                        default:
                    }
                }
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da informação do equipamento");

                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    };

    /**
     * Save Equipment detail
     */
    this._SaveEquipmentDetail = function()
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);
        $('#id-modal-deposition-point-tool-equipment-in-dp').hide();

        var equipmentObj = $('#id-modal-deposition-point-tool-equipment-in-dp-body-form').serializeJSON();

        $.ajax({
            type: 'POST',
            url: '/rest/app/DepositionPointTool/SaveEquipmentDetail',
            data: JSON.stringify(equipmentObj),
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na gravação do equipamento");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myDepositionPointTool._equipmentDpDatatable.cell('#' + equipmentObj.IdEquipamento, 3).data(equipmentObj.Equipamento).draw();
                            myDepositionPointTool._equipmentDpDatatable.cell('#' + equipmentObj.IdEquipamento, 4).data(equipmentObj.IdTipoEquipamento).draw();
                            myDepositionPointTool._equipmentDpDatatable.cell('#' + equipmentObj.IdEquipamento, 5).data(equipmentObj.TipoEquipamento).draw();
                            myDepositionPointTool._equipmentDpDatatable.cell('#' + equipmentObj.IdEquipamento, 6).data(equipmentObj.TipoFluxo).draw();
                            myDepositionPointTool._equipmentDpDatatable.cell('#' + equipmentObj.IdEquipamento, 7).data(equipmentObj.TipoCapacidadeContentor).draw();
                            myDepositionPointTool._equipmentDpDatatable.cell('#' + equipmentObj.IdEquipamento, 8).data(equipmentObj.Quantidade).draw();

                            toastr["success"]("Equipamento gravado com sucesso");
                            break;
                        default:
                            toastr["error"]("Erro na gravação do equipamento");
                    }
                }

                // Stop wait
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na gravação do equipamento");
                // Stop wait
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    }

    /**
     * Delete equipment
     */
    this._DeleteEquipment = function(idEquipment)
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        $('#id-modal-deposition-point-tool-delete-confirm').hide();

        $.ajax({
            type: 'GET',
            url: '/rest/app/DepositionPointTool/GetDeleteEquipment?idEquipment=' + idEquipment,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na remoção do equipamento");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myDepositionPointTool._equipmentDpDatatable.row('#' + idEquipment).remove().draw();

                            toastr["success"]("Equipamento removido com sucesso");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na remoção do equipamento");
                            break;
                        default:
                    }
                }
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na remoção do equipamento");

                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    }


    /**
     * Delete producer
     * @param {int} idProducer, producer identifier
     */
    this._DeleteProducer = function(idProducer)
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        $('#id-modal-deposition-point-tool-delete-confirm').hide();

        $.ajax({
            type: 'GET',
            url: '/rest/app/DepositionPointTool/GetDeleteProducer?idProducer=' + idProducer,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na remoção do produtor");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myDepositionPointTool._producerDatatable.row('#' + idProducer).remove().draw();

                            toastr["success"]("Produtor removido com sucesso");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na remoção do produtor");
                            break;
                        default:
                    }
                }
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na remoção do produtor");

                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    }

    /**
     * Delete equipment intervention
     */
    this._DeleteEquipmentIntervention = function(idEquipmentIntervention)
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        $('#id-modal-deposition-point-tool-delete-confirm').hide();

        $.ajax({
            type: 'GET',
            url: '/rest/app/DepositionPointTool/GetDeleteEquipmentIntervention?idEquipmentIntervention=' + idEquipmentIntervention,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na remoção do intervenção");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myDepositionPointTool._equipmentInterventionDatatable.row('#' + idEquipmentIntervention).remove().draw();

                            toastr["success"]("Intervenção removido com sucesso");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na remoção do intervenção");
                            break;
                        default:
                    }
                }
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na remoção do intervenção");

                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    }

    /**
     * Delete observation
     */
    this._DeleteObservation = function(idObservation)
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        $('#id-modal-deposition-point-tool-delete-confirm').hide();

        $.ajax({
            type: 'GET',
            url: '/rest/app/DepositionPointTool/GetDeleteObservation?idObservation=' + idObservation,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na remoção da observação");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myDepositionPointTool._depositionPointObservationDatatable.row('#' + idObservation).remove().draw();

                            toastr["success"]("Observação removida com sucesso");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na remoção da observação");
                            break;
                        default:
                    }
                }
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na remoção da observação");

                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    }

    /**
     * Get producer detail
     * @param {int} idProducer, producer identifier
     */
    this._GetProducerDetail = function(idProducer)
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        // Clean modal equipment intervation detail
        $('#id-deposition-point-producer-detail-entity').val('').trigger('change');
        $('#id-modal-deposition-point-tool-producer-body-form input').val('');

        $.ajax({
            type: 'GET',
            url: '/rest/app/DepositionPointTool/GetProducerDetail?idProducer=' + idProducer,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da informação do produtor");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var producer = data.result.producer;

                            // Fill equipment detail
                            $('#id-modal-deposition-point-tool-producer-body-form input[name="IdProdutor"]').val(producer.idprodutor);
                            $('#id-modal-deposition-point-tool-producer-body-form input[name="IdEntidade"]').val(producer.identidade);
                            $('#id-modal-deposition-point-tool-producer-body-form input[name="Entidade"]').val(producer.entidade);
                            $('#id-modal-deposition-point-tool-producer-body-form input[name="IdTipoCliente"]').val(producer.idtipocliente);
                            $('#id-modal-deposition-point-tool-producer-body-form input[name="TipoCliente"]').val(producer.tipocliente);
                            $('#id-modal-deposition-point-tool-producer-body-form input[name="Fraccao"]').val(producer.fraccao);
                            $('#id-modal-deposition-point-tool-producer-body-form input[name="IdPontoDeposicao"]').val(producer.idpontodeposicao);

                            // Set mode
                            $('#id-modal-deposition-point-tool-producer-save').attr('mode', 'update');

                            // Show modal
                            $('#id-modal-deposition-point-tool-producer').show();
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na obtenção da informação do produtor");
                            break;
                        default:
                    }
                }
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da informação do produtor");

                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    };

    /**
     * Get equipment intervention detail
     * @param {int} idEquipmentIntervention, equipment intervention identifier
     */
    this._GetEquipmentInterventionDetail = function(idEquipmentIntervention)
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        // Clean modal equipment intervation detail
        $('#id-modal-deposition-point-tool-equipment-intervention-body-form input').val('');
        $('#id-modal-deposition-point-tool-equipment-intervention-body-form textarea').val('');
        $('#id-modal-deposition-point-tool-equipment-intervention-body-type-intervention').val('').change();

        $.ajax({
            type: 'GET',
            url: '/rest/app/DepositionPointTool/GetEquipmentInterventionDetail?idEquipmentIntervention=' + idEquipmentIntervention,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da informação da intervenção equipamento");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var equipmentIntervention = data.result.equipmentIntervention;

                            // Fill equipment detail
                            $('#id-modal-deposition-point-tool-equipment-intervention-body-form input[name="IdEquipamentoIntervencao"]').val(equipmentIntervention.idequipamentointervencao);
                            $('#id-modal-deposition-point-tool-equipment-intervention-body-form textarea[name="EquipamentoIntervencao"]').val(equipmentIntervention.equipamentointervencao);
                            $('#id-modal-deposition-point-tool-equipment-intervention-body-form select[name="IdTipoIntervencao"]').val(equipmentIntervention.idtipointervencao);
                            $('#id-modal-deposition-point-tool-equipment-intervention-body-form select[name="IdTipoIntervencao"]').selectpicker("refresh");
                            $('#id-modal-deposition-point-tool-equipment-intervention-body-form input[name="DataIntervencao"]').val(myDepositionPointTool._utility.TransformDateServerInDateII(equipmentIntervention.dataintervencao));

                            // Set mode
                            $('#id-modal-deposition-point-tool-equipment-intervention-save').attr('mode', 'update');

                            // Show modal
                            $('#id-modal-deposition-point-tool-equipment-intervention').show();
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na obtenção da informação da intervenção equipamento");
                            break;
                        default:
                    }
                }
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da informação da intervenção equipamento");

                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    };

    /**
     * Get observation
     * @param {int} idObservation, observation identifier
     */
    this._GetDepositionPointObservation = function(idObservation)
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        // Clean modal observation detail
        $('#id-modal-deposition-point-tool-observation-body-form input').val('');
        $('#id-modal-deposition-point-tool-observation-body-form textarea').val('');

        $.ajax({
            type: 'GET',
            url: '/rest/app/DepositionPointTool/GetObservationDetail?idObservation=' + idObservation,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da observação");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var observation = data.result.observation;

                            // Fill equipment detail
                            $('#id-modal-deposition-point-tool-observation-body-form input[name="IdPontoDeposicaoObservacao"]').val(observation.idpontodeposicaoobservacao);
                            $('#id-modal-deposition-point-tool-observation-body-form textarea[name="PontoDeposicaoObservacao"]').val(observation.pontodeposicaoobservacao);
                            $('#id-modal-deposition-point-tool-observation-body-form input[name="IdPontoDeposicao"]').val(observation.idpontodeposicao);
                            $('#id-modal-deposition-point-tool-observation-body-form input[name="Data"]').val(myDepositionPointTool._utility.TransformDateServerInDateII(observation.data));

                            // Set mode
                            $('#id-modal-deposition-point-tool-observation-save').attr('mode', 'update');

                            // Show modal
                            $('#id-modal-deposition-point-tool-observation').show();
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na obtenção da observação");
                            break;
                        default:
                    }
                }
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da observação");

                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    };

    /**
     * Get all feature from a buffer
     */
    this.GetFeatureBufferForCombo = function(x, y, radius, geoserver, workspace, layerName, geomColumnName, idComboNode, valueSelect)
    {
        // Filter buffer
        var cqlFilterIntersect = 'DWITHIN(' + geomColumnName + ', POINT(' + x + ' ' + y + '), ' + radius + ', meters)';

        // Url
        var featureUrl = geoserver + "/wfs";

        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: featureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "cql_filter": cqlFilterIntersect,
                //"propertyName": 'geom',
                "outputFormat": 'application/json'
            }
        });

        getFeature.done(function (data, textStatus, jqXHR)
        {
            if (data.features)
            {
                switch(layerName)
                {
                    case "VW_FREGUESIATROCO":
                        myDepositionPointTool._hashReferenceCombo["section"] = {};
                        break;
                    default:
                        // do nothing
                }
                var comboArray = [];
                var valueToSelect = valueSelect;
                var hashDistance = {};
                for (var i = 0; i < data.features.length; i++) {
                    var feature =  (new GeoJSON()).readFeatures(data)[i];
                    switch(layerName)
                    {
                        case "FREGUESIA":
                            comboArray.push({ "id": feature.getProperties().IDFREGUESIA, "value": feature.getProperties().FREGUESIA });
                            if(!valueToSelect && myDepositionPointTool._mapSgs.CheckFeaturePointInFeaturePolygon(myDepositionPointTool._featureInfo.feature, feature))
                                valueToSelect = feature.getProperties().IDFREGUESIA;
                            break;
                        case "VW_FREGUESIATROCO":
                            var distance = myDepositionPointTool._mapSgs.GetDistanceBetweenPointAndLine(myDepositionPointTool._featureInfo.feature, feature);
                            var obj = { "id": feature.getProperties().IDFREGUESIATROCO, "value": feature.getProperties().RUA, "distance": distance };
                            if(myDepositionPointTool._hashReferenceCombo["section"][feature.getProperties().IDFREGUESIA])
                                myDepositionPointTool._hashReferenceCombo["section"][feature.getProperties().IDFREGUESIA].push(obj);
                            else
                                myDepositionPointTool._hashReferenceCombo["section"][feature.getProperties().IDFREGUESIA] = [obj];
                            break;
                        default:
                            // do nothing
                    }
                }
                switch(layerName)
                {
                    case "FREGUESIA":
                        myDepositionPointTool._utility.FillSelect(idComboNode, comboArray, 'value', 'id', true);

                        $('#' + idComboNode).selectpicker('val', valueToSelect);
                        break;
                    case "VW_FREGUESIATROCO":
                        // Compose Object
                        for(var y = 0; y < Object.keys(myDepositionPointTool._hashReferenceCombo["section"]).length; y++)
                        {
                            var idFreguesia = Object.keys(myDepositionPointTool._hashReferenceCombo["section"])[y];
                            var comboArrayFreguesia = myDepositionPointTool._hashReferenceCombo["section"][idFreguesia];
                            // sort array by troco name and distance
                            comboArrayFreguesia.sort(function(a,b){ if(a.value == b.value) return (a.distance > b.distance)?1:-1; return (a.value > b.value)?1:-1; } );
                            // get troços closer
                            var newComboArray = [];
                            comboArrayFreguesia.forEach(function(el, i) {
                                if(el.id === valueToSelect)
                                {
                                    newComboArray.push(el);
                                }
                                else {
                                    if(i==0)
                                        newComboArray.push(el);
                                    else
                                    {
                                        if(el.value != comboArrayFreguesia[i-1].value) newComboArray.push(el);
                                    }
                                }
                            });
                            // Sort array by distance
                            newComboArray.sort(function(a,b){ return (a.distance > b.distance)?1:-1; } );
                            // Set the hash freguesia with new array
                            myDepositionPointTool._hashReferenceCombo["section"][idFreguesia] = newComboArray;
                        }

                        // Set combo for the freguesia selected
                        var idFreguesiaSelected = $('#prop_assoc_IDFREGUESIA').val();
                        var comboArrayToView = myDepositionPointTool._hashReferenceCombo["section"][idFreguesiaSelected];
                        if(comboArrayToView)
                        {
                            myDepositionPointTool._utility.FillSelect(idComboNode, comboArrayToView, 'value', 'id', false);

                            if(!valueToSelect)
                                valueToSelect = comboArrayToView[0].id;
                            $('#' + idComboNode).selectpicker('val', valueToSelect);
                        }
                        break;
                    default:
                        // do nothing
                }
            }
        });
    };

    /**
     * Get Layer information
     * @param {string} layerName
     */
    this.GetLayerInformation = function(layerName)
    {
    
        $.ajax({
            type: 'GET',
            url: '/rest/app/Layer/GetLayerSourceByName?layerName=' + layerName,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção de informação de camadas");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myDepositionPointTool._layerInformation[layerName] = data.result.layerSource;
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na obtenção de informação de camadas");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção de informação de camadas");
            }
        });
    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    $('#id-buttonsearchDepositionPointTool').on('click', function () {
        myDepositionPointTool._SearchDepositionPoints();
    });

    /**
     * Modal equipment detail - Event close modal detail equipment associate to deposition point
     */
    $('#id-modal-deposition-point-tool-equipment-in-dp-close').off('click').on('click', function () {
        $('#id-modal-deposition-point-tool-equipment-in-dp').hide();
    });

    /**
     * Modal equipment detail - Event save modal detail equipment associate to deposition point
     */
    $('#id-modal-deposition-point-tool-equipment-in-dp-save').off('click').on('click', function () {
        myDepositionPointTool._SaveEquipmentDetail();
    });

    /**
     * Modal equipment detail - Event open type equipment for selection
     */
    $('#id-modal-deposition-point-tool-equipment-in-dp-view-table').off('click').on('click', function () {
        // Hide modal equipment detail
        $('#id-modal-deposition-point-tool-equipment-in-dp').hide();

        // Change mode type equipment
        $('#id-modal-deposition-point-tool-equipment-save').attr('mode', 'select');
        $('#id-modal-deposition-point-tool-equipment-save i')[0].setAttribute("class", "fa fa-plus-square");

        // Show equipment type modal
        $('#id-modal-deposition-point-tool-equipment').show();
    });

    /**
     * Modal select type equipment - Close new equipment type
     */
    $('#id-modal-deposition-point-tool-equipment-close').off('click').on('click', function () {
        $('#id-modal-deposition-point-tool-equipment').hide();

        // If mode select then open equipment detail modal
        if($('#id-modal-deposition-point-tool-equipment-save').attr('mode') === 'select')
            $('#id-modal-deposition-point-tool-equipment-in-dp').show();
    });

    /**
     * Modal select type equipment - Close new equipment type
     */
    $('#id-modal-deposition-point-tool-equipment-save').off('click').on('click', function () {
        let selectedRow = $("#id-modal-deposition-point-tool-equipment-body-table tbody tr.selected")

        if (selectedRow !== undefined && selectedRow.length > 0) {
            let idTipoEquipamento = selectedRow[0].id;

            let listTiposEquipamentos = myDepositionPointTool._hashReference['tipos_equipamentos_list'];

            let tipoEquipamento = listTiposEquipamentos.filter(function (x) {
                return x.idTipoEquipamento == idTipoEquipamento;
            });

            // Mode select
            if($('#id-modal-deposition-point-tool-equipment-save').attr('mode') === 'select')
            {
                $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="Equipamento"]').val(tipoEquipamento[0].tipoEquipamento);
                $('#id-modal-deposition-point-tool-equipment-in-dp-title').html("Equipamento - " + tipoEquipamento[0].tipoEquipamento);
                $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="IdTipoEquipamento"]').val(tipoEquipamento[0].idTipoEquipamento);
                $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="TipoEquipamento"]').val(tipoEquipamento[0].tipoEquipamento);
                $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="TipoFluxo"]').val(tipoEquipamento[0].tipoFluxo);
                $('#id-modal-deposition-point-tool-equipment-in-dp-body-form input[name="TipoCapacidadeContentor"]').val(tipoEquipamento[0].tipoCapacidadeContentor);
            }

            // Mode create new equipment
            if($('#id-modal-deposition-point-tool-equipment-save').attr('mode') === 'save')
            {
                myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

                var equipmentObj = {
                    Equipamento: tipoEquipamento[0].tipoEquipamento,
                    IdTipoEquipamento: tipoEquipamento[0].idTipoEquipamento,
                    Quantidade: 1,
                    IdPontoDeposicao: $('#id-offcanvas-body-layer-detail-equipamentos-btn-add-equipamento').attr('id-deposition-point')
                };

                $.ajax({
                    type: 'POST',
                    url: '/rest/app/DepositionPointTool/AddEquipmentDetail',
                    data: JSON.stringify(equipmentObj),
                    dataType: 'json',
                    contentType: "application/json",
                    success: function (data) {
                        if (data.error) {
                            toastr["error"]("Erro na adição do equipamento");
                        }
                        else {
                            switch (data.result.status) {
                                case 'SUCCESS':
                                    var equipment = data.result.equipment;
                                    myDepositionPointTool._equipmentDpDatatable.row.add({
                                        idEquipamento: equipment.idequipamento,
                                        equipamento: equipment.equipamento,
                                        idTipoEquipamento: equipment.idtipoequipamento,
                                        tipoEquipamento: equipment.tipoequipamento,
                                        tipoFluxo: equipment.tipofluxo,
                                        tipoCapacidadeContentor: equipment.tipocapacidadecontentor,
                                        quantidade: equipment.quantidade
                                    });
                                    myDepositionPointTool._equipmentDpDatatable.draw();

                                    toastr["success"]("Equipamento adicionado com sucesso");
                                    break;
                                default:
                                    toastr["error"]("Erro na adição do equipamento");
                            }
                        }

                        // Stop wait
                        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                    },
                    error: function (request, status, error) {
                        toastr["error"]("Erro na adição do equipamento");
                        // Stop wait
                        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                    }
                });
            }
        }

        // Close modal type equipment
        $('#id-modal-deposition-point-tool-equipment-close').click();

        // If mode select then open equipment detail modal
        if($('#id-modal-deposition-point-tool-equipment-save').attr('mode') === 'select')
            $('#id-modal-deposition-point-tool-equipment-in-dp').show();
    });

    /**
     * Modal select type equipment - search button
     */
    $('#id-modal-deposition-point-tool-equipment-search-filter').off('click').on('click', function () {
        var type = $("#id-modal-deposition-point-tool-equipment-body-type-filter").val();
        var flux = $("#id-modal-deposition-point-tool-equipment-body-flux-filter").val();
        var capacity = $("#id-modal-deposition-point-tool-equipment-body-capacity-filter").val();

        let listTiposEquipamentos = myDepositionPointTool._hashReference['tipos_equipamentos_list'];

        if (type !== "") {
            listTiposEquipamentos = listTiposEquipamentos.filter(function (x) {
                return x.tipoEquipamento.includes(type);
            });
        }

        if (flux !== "") {
            listTiposEquipamentos = listTiposEquipamentos.filter(function (x) {
                return x.tipoFluxo.includes(flux);
            });
        }

        if (capacity !== "") {
            listTiposEquipamentos = listTiposEquipamentos.filter(function (x) {
                return x.tipoCapacidadeContentor.includes(capacity);
            });
        }

        var columnValueArray = [];

        listTiposEquipamentos.forEach(x => {
            var objRow = {};

            objRow["idTipoEquipamento"] = x.idTipoEquipamento;
            objRow["tipoEquipamento"] = x.tipoEquipamento;
            objRow["tipoFluxo"] = x.tipoFluxo;
            objRow["tipoCapacidadeContentor"] = x.tipoCapacidadeContentor;

            columnValueArray.push(objRow);
        });

        // Destroy if exists
        if (myDepositionPointTool._equipmentDatatable != null) {

            // Destroy table
            myDepositionPointTool._equipmentDatatable.destroy();

            // Empty table zone
            $('#id-modal-deposition-point-tool-equipment-body-table-container').empty();

            // Recreate table node
            var tableSearch = $('<table id="id-modal-deposition-point-tool-equipment-body-table" class="table table-striped table-bordered table-hover" width="100%"></table>');
            tableSearch.appendTo($('#id-modal-deposition-point-tool-equipment-body-table-container'));
        }

        myDepositionPointTool._equipmentDatatable = $('#id-modal-deposition-point-tool-equipment-body-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum elemento',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": true,
            "info": false,
            //"scrollY": $('#offcanvas-search-result-table-zone').height() - 80,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": true,
            "pageLength": 5,
            "ordering": false,
            "columns": myDepositionPointTool._hashColumDefinition.column_definition,
            "data": columnValueArray,
            "select": false,
            "name": "equipment_table",
            "rowId": 'idTipoEquipamento'
        });

        $('#id-modal-deposition-point-tool-equipment-body-table tbody').on('click', 'tr', function () {
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
            }
            else {
                myDepositionPointTool._equipmentDatatable.$('tr.selected').removeClass('selected');
                $(this).addClass('selected');
            }
        });
    });

    /**
     * Modal select type equipment - Clear search
     */
    $('#id-modal-deposition-point-tool-equipment-clear-filter').off('click').on('click', function () {
        $("#id-modal-deposition-point-tool-equipment-body-type-filter").val("");
        $("#id-modal-deposition-point-tool-equipment-body-flux-filter").val("");
        $("#id-modal-deposition-point-tool-equipment-body-capacity-filter").val("");

        let listTiposEquipamentos = myDepositionPointTool._hashReference['tipos_equipamentos_list'];

        var columnValueArray = [];

        listTiposEquipamentos.forEach(x => {
            var objRow = {};

            objRow["idTipoEquipamento"] = x.idTipoEquipamento;
            objRow["tipoEquipamento"] = x.tipoEquipamento;
            objRow["tipoFluxo"] = x.tipoFluxo;
            objRow["tipoCapacidadeContentor"] = x.tipoCapacidadeContentor;

            columnValueArray.push(objRow);
        });

        // Destroy if exists
        if (myDepositionPointTool._equipmentDatatable != null) {

            // Destroy table
            myDepositionPointTool._equipmentDatatable.destroy();

            // Empty table zone
            $('#id-modal-deposition-point-tool-equipment-body-table-container').empty();

            // Recreate table node
            var tableSearch = $('<table id="id-modal-deposition-point-tool-equipment-body-table" class="table table-striped table-bordered table-hover" width="100%"></table>');
            tableSearch.appendTo($('#id-modal-deposition-point-tool-equipment-body-table-container'));
        }

        myDepositionPointTool._equipmentDatatable = $('#id-modal-deposition-point-tool-equipment-body-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum elemento',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": true,
            "info": false,
            //"scrollY": $('#offcanvas-search-result-table-zone').height() - 80,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": true,
            "pageLength": 5,
            "ordering": false,
            "columns": myDepositionPointTool._hashColumDefinition.column_definition,
            "data": columnValueArray,
            "select": false,
            "name": "equipment_table",
            "rowId": 'idTipoEquipamento'
        });

        $('#id-modal-deposition-point-tool-equipment-body-table tbody').on('click', 'tr', function () {
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
            }
            else {
                myDepositionPointTool._equipmentDatatable.$('tr.selected').removeClass('selected');
                $(this).addClass('selected');
            }
        });
    });

    /**
     * Delete confirm - Confirm delete
     */
    $('#id-modal-deposition-point-tool-delete-confirm-btn').off('click').on('click', function () {
        var idElement = $('#id-modal-deposition-point-tool-delete-confirm-btn').attr("id-element");
        var elementType = $('#id-modal-deposition-point-tool-delete-confirm-btn').attr("element-type");

        switch(elementType)
        {
            case "equipment":
                myDepositionPointTool._DeleteEquipment(idElement);
                break;
            case "producer":
                myDepositionPointTool._DeleteProducer(idElement);
                break;
            case "equipment-intervention":
                myDepositionPointTool._DeleteEquipmentIntervention(idElement);
                break;
            case "observation":
                myDepositionPointTool._DeleteObservation(idElement);
                break;
            default:
                // Do nothing
        }
    });

    /**
     * Delete confirm - Cancel delete
     */
    $('#id-modal-deposition-point-tool-delete-cancel-btn').off('click').on('click', function () {
        $('#id-modal-deposition-point-tool-delete-confirm').hide();
    });

    /**
     * Modal intervention - Close modal
     */
    $('#id-modal-deposition-point-tool-equipment-intervention-close').off('click').on('click', function () {
        $('#id-modal-deposition-point-tool-equipment-intervention').hide();
    });

    /**
     * Modal intervention - update or create equipment intervention
     */
    $('#id-modal-deposition-point-tool-equipment-intervention-save').off('click').on('click', function ()
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);
        $('#id-modal-deposition-point-tool-equipment-intervention').hide();

        var equipmentInterventionObj = $('#id-modal-deposition-point-tool-equipment-intervention-body-form').serializeJSON();

        // Update
        if($('#id-modal-deposition-point-tool-equipment-intervention-save').attr('mode') === 'update')
        {
            $.ajax({
                type: 'POST',
                url: '/rest/app/DepositionPointTool/SaveEquipmentInterventionDetail',
                data: JSON.stringify(equipmentInterventionObj),
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro na gravação da intervenção do equipamento");
                    }
                    else {
                        switch (data.result.status) {
                            case 'SUCCESS':
                                var equipmentIntervention = data.result.equipmentIntervention;

                                myDepositionPointTool._equipmentInterventionDatatable.cell('#' + equipmentInterventionObj.IdEquipamentoIntervencao, 2).data(equipmentIntervention.equipamentointervencao).draw();
                                myDepositionPointTool._equipmentInterventionDatatable.cell('#' + equipmentInterventionObj.IdEquipamentoIntervencao, 3).data(equipmentIntervention.idtipointervencao).draw();
                                myDepositionPointTool._equipmentInterventionDatatable.cell('#' + equipmentInterventionObj.IdEquipamentoIntervencao, 4).data(equipmentIntervention.tipointervencao).draw();
                                myDepositionPointTool._equipmentInterventionDatatable.cell('#' + equipmentInterventionObj.IdEquipamentoIntervencao, 5).data(myDepositionPointTool._utility.TransformDateServerInDateII(equipmentIntervention.dataintervencao)).draw();

                                toastr["success"]("Intervenção de equipamento gravado com sucesso");
                                break;
                            default:
                                toastr["error"]("Erro na gravação da intervenção do equipamento");
                        }
                    }

                    // Stop wait
                    myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na gravação da intervenção do equipamento");
                    // Stop wait
                    myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                }
            });
        }

        // Create
        if($('#id-modal-deposition-point-tool-equipment-intervention-save').attr('mode') === 'create')
        {
            $.ajax({
                type: 'POST',
                url: '/rest/app/DepositionPointTool/AddEquipmentInterventionDetail',
                data: JSON.stringify(equipmentInterventionObj),
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro na criação da intervenção do equipamento");
                    }
                    else {
                        switch (data.result.status) {
                            case 'SUCCESS':
                                var equipmentIntervention = data.result.newEquipmentIntervention;
                                myDepositionPointTool._equipmentInterventionDatatable.row.add({
                                    idEquipamentoIntervencao: equipmentIntervention.idequipamentointervencao,
                                    equipamentoIntervencao: equipmentIntervention.equipamentointervencao,
                                    idTipoIntervencao: equipmentIntervention.idtipointervencao,
                                    tipoIntervencao: equipmentIntervention.tipointervencao,
                                    dataIntervencao: myDepositionPointTool._utility.TransformDateServerInDateII(equipmentIntervention.dataintervencao)
                                });

                                myDepositionPointTool._equipmentInterventionDatatable.draw();
                                toastr["success"]("Intervenção de equipamento criado com sucesso");
                                break;
                            default:
                                toastr["error"]("Erro na criação da intervenção do equipamento");
                        }
                    }

                    // Stop wait
                    myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na criação da intervenção do equipamento");
                    // Stop wait
                    myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                }
            });
        }
    });

    /**
     * Modal Observation - Close modal
     */
    $('#id-modal-deposition-point-tool-observation-close').off('click').on('click', function () {
        $('#id-modal-deposition-point-tool-observation').hide();
    });

    /**
     * Modal Observation - update or create observation
     */
    $('#id-modal-deposition-point-tool-observation-save').off('click').on('click', function ()
    {
        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);
        $('#id-modal-deposition-point-tool-observation').hide();

        var observationObj = $('#id-modal-deposition-point-tool-observation-body-form').serializeJSON();

        // Update
        if($('#id-modal-deposition-point-tool-observation-save').attr('mode') === 'update')
        {
            $.ajax({
                type: 'POST',
                url: '/rest/app/DepositionPointTool/SaveObservation',
                data: JSON.stringify(observationObj),
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro na gravação da observação");
                    }
                    else {
                        switch (data.result.status) {
                            case 'SUCCESS':
                                var observation = data.result.observation;

                                myDepositionPointTool._depositionPointObservationDatatable.cell('#' + observationObj.IdPontoDeposicaoObservacao, 2).data(observation.pontodeposicaoobservacao).draw();
                                myDepositionPointTool._depositionPointObservationDatatable.cell('#' + observationObj.IdPontoDeposicaoObservacao, 3).data(myDepositionPointTool._utility.TransformDateServerInDateII(observation.data)).draw();

                                toastr["success"]("Observação do ponto de deposição gravado com sucesso");
                                break;
                            default:
                                toastr["error"]("Erro na gravação da observação");
                        }
                    }

                    // Stop wait
                    myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na gravação da observação");
                    // Stop wait
                    myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                }
            });
        }

        // Create
        if($('#id-modal-deposition-point-tool-observation-save').attr('mode') === 'create')
        {
            $.ajax({
                type: 'POST',
                url: '/rest/app/DepositionPointTool/AddObservation',
                data: JSON.stringify(observationObj),
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro na criação da observação");
                    }
                    else {
                        switch (data.result.status) {
                            case 'SUCCESS':
                                var observation = data.result.observation;
                                myDepositionPointTool._depositionPointObservationDatatable.row.add({
                                    idPontoDeposicaoObservacao: observation.idpontodeposicaoobservacao,
                                    pontoDeposicaoObservacao: observation.pontodeposicaoobservacao,
                                    data: myDepositionPointTool._utility.TransformDateServerInDateII(observation.data),
                                    idPontoDeposicao: observation.idpontodeposicao
                                });

                                myDepositionPointTool._depositionPointObservationDatatable.draw();
                                toastr["success"]("Observações do ponto de deposição criado com sucesso");
                                break;
                            default:
                                toastr["error"]("Erro na criação da observação");
                        }
                    }

                    // Stop wait
                    myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na criação da observação");
                    // Stop wait
                    myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                }
            });
        }
    });

    /**
     * Modal producer - Close modal
     */
    $('#id-modal-deposition-point-tool-producer-close').off('click').on('click', function () {
        $('#id-modal-deposition-point-tool-producer').hide();
    });

    /**
     * Modal producer - Button select entity
     */
    $('#id-deposition-point-producer-detail-btn-choose-entity').off('click').on('click', function () {
        // Clean form producer detailt
        $('#id-modal-deposition-point-tool-producer-body-entity').val('');
        $('#id-modal-deposition-point-tool-producer-body-id-entity').val('');
        $('#id-modal-deposition-point-tool-producer-body-client-type').val('');
        $('#id-modal-deposition-point-tool-producer-body-id-client-type').val('');
        $('#id-modal-deposition-point-tool-producer-body-fraction').val('');

        // fill
        $('#id-modal-deposition-point-tool-producer-body-entity').val(myDepositionPointTool._entitySelectedForProducer.text);
        $('#id-modal-deposition-point-tool-producer-body-id-entity').val(myDepositionPointTool._entitySelectedForProducer.id);
        $('#id-modal-deposition-point-tool-producer-body-client-type').val(myDepositionPointTool._entitySelectedForProducer.ClientType);
        $('#id-modal-deposition-point-tool-producer-body-id-client-type').val(myDepositionPointTool._entitySelectedForProducer.idClientType);
        $('#id-modal-deposition-point-tool-producer-body-fraction').val(myDepositionPointTool._entitySelectedForProducer.Fraction);
    });

    /**
     * Modal producer - update or create producer
     */
    $('#id-modal-deposition-point-tool-producer-save').off('click').on('click', function ()
    {
        var producerObj = $('#id-modal-deposition-point-tool-producer-body-form').serializeJSON();
        if(producerObj.IdProdutor === "")
            producerObj.IdProdutor = -1;
        if(producerObj.IdTipoCliente === "")
            producerObj.IdTipoCliente = -1;

        if(producerObj.Entidade === "")
        {
            toastr["warning"]("Seleccione primeiro uma entidade");
            return;
        }

        myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);
        $('#id-modal-deposition-point-tool-producer').hide();

        // Update
        if($('#id-modal-deposition-point-tool-producer-save').attr('mode') === 'update')
        {
            $.ajax({
                type: 'POST',
                url: '/rest/app/DepositionPointTool/SaveProducer',
                data: JSON.stringify(producerObj),
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro na gravação do produtor");
                    }
                    else {
                        switch (data.result.status) {
                            case 'SUCCESS':
                                var producer = data.result.producerSaved;

                                myDepositionPointTool._producerDatatable.cell('#' + producer.idprodutor, 3).data(producer.identidade).draw();
                                myDepositionPointTool._producerDatatable.cell('#' + producer.idprodutor, 4).data(producer.entidade).draw();
                                myDepositionPointTool._producerDatatable.cell('#' + producer.idprodutor, 5).data(producer.idtipocliente).draw();
                                myDepositionPointTool._producerDatatable.cell('#' + producer.idprodutor, 6).data(producer.tipocliente).draw();
                                myDepositionPointTool._producerDatatable.cell('#' + producer.idprodutor, 7).data(producer.fraccao).draw();
                                
                                toastr["success"]("Produtor do ponto de deposição gravado com sucesso");
                                break;
                            case "ALREADY_EXIST":
                                toastr["warning"]("Produtor já se encontra associado a esta entidade");
                                $('#id-modal-deposition-point-tool-producer').show();
                                break;
                            default:
                                toastr["error"]("Erro na gravação do produtor");
                        }
                    }

                    // Stop wait
                    myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na gravação do produtor");
                    // Stop wait
                    myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                }
            });
        }

        // Create
        if($('#id-modal-deposition-point-tool-producer-save').attr('mode') === 'create')
        {
            $.ajax({
                type: 'POST',
                url: '/rest/app/DepositionPointTool/AddProducer',
                data: JSON.stringify(producerObj),
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro na criação do produtor");
                    }
                    else {
                        switch (data.result.status) {
                            case 'SUCCESS':
                                var producer = data.result.newProducer;

                                myDepositionPointTool._producerDatatable.row.add({
                                    idProdutor: producer.idprodutor,
                                    idEntidade: producer.identidade,
                                    entidade: producer.entidade,
                                    idTipoCliente: producer.idtipocliente,
                                    tipoCliente: producer.tipocliente,
                                    fraccao: producer.fraccao,
                                    idPontoDeposicao: producer.idpontodeposicao
                                });
                                myDepositionPointTool._producerDatatable.draw();

                                toastr["success"]("Produtor do ponto de deposição criado com sucesso");
                                break;
                            case "ALREADY_EXIST":
                                toastr["warning"]("Produtor já se encontra associado a esta entidade");
                                $('#id-modal-deposition-point-tool-producer').show();
                                break;
                            default:
                                toastr["error"]("Erro na criação do produtor");
                        }
                    }

                    // Stop wait
                    myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na criação do produtor");
                    // Stop wait
                    myDepositionPointTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                }
            });
        }
    });

    // -- end event -------------------------------------------------------------------------------
};

/**
 * Init deposition point tool
 * @param {object} mapSgs, map object
 */
DepositionPointTool.prototype.Init = function (mapSgs) {
    if (!this._toolInitialize) {
        this._toolInitialize = true;

        var this_ = this;

        // Set map info
        this._mapSgs = mapSgs;

        // Layer civil protection name
        this._LayerDepositionName = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "DEPOSITION_POINT_TOOL", "LAYER_INFO", "LAYER_NAME").value;

        // Get deposition point identifier column name
        this._depositionPointIdColumnName = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "DEPOSITION_POINT_TOOL", "LAYER_INFO", "ID_COLUMN_NAME").value;

        // -- Get all references -----------------------------------------------------------------
        this._GetAllReferences();

        // -- Init date for equipment -------------------------------------------------------------
        $('#id-modal-deposition-point-tool-equipment-in-dp-body-date').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });
        $('#id-modal-deposition-point-tool-equipment-intervention-body-date-intervention').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });
        $('#id-modal-deposition-point-tool-observation-body-date').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Init upload -------------------------------------------------------------------------
        if (this._mapSgs._settings._mapSettings.operation_visible.Upload)
        {
            this._uploadAttachtment = new Upload(this._mapSgs._settings._mapSettings.user_info.id_user);
            this._uploadAttachtment._fileEditorTemplate =  this._fileEditorTemplateForEquipment;
            this._uploadAttachtment._fileEditorTemplateFileZoneDivWithExpand = this._fileEditorTemplateFileZoneDivWithExpandForEquipment;
            this._uploadAttachtment._fileEditorTemplateFileZoneDivNoExpand = this._fileEditorTemplateFileZoneDivNoExpandForEquipment;
        }

        // -- Get information layer not in layer tree ---------------------------------------------
        this.GetLayerInformation("FREGUESIA");
        this.GetLayerInformation("VW_FREGUESIATROCO");

        // -- Select2 for entity of producer of deposition point ----------------------------------
        $('#id-deposition-point-producer-detail-entity').select2(
        {
            ajax:
            {
                type: 'GET',
                url: '/rest/app/DepositionPointTool/GetAllEntityBeginWith',
                dataType: 'json',
                delay: 250,
                data: function (term) {
                    return term;
                },
                processResults: function (data) {
                    var listEntity = data.result;
                    if (listEntity === null)
                        return {
                            "results": [],
                            "pagination": {
                                "more": true
                            }
                        }

                    var resultArray = [];
                    for (var i = 0; i < listEntity.length; i++) {
                        var entityObj = listEntity[i];
                        resultArray.push({
                            "text": entityObj.entity,
                            "id": entityObj.idEntity,
                            "idClientType": entityObj.IdClientType,
                            "ClientType": entityObj.ClientType,
                            "Fraction": entityObj.Fraction
                        })
                    }

                    return {
                        "results": resultArray,
                        "pagination": {
                            "more": true
                        }
                    }
                }
            },
            minimumInputLength: 2,
            language: "pt",
            dropdownParent: $('#id-modal-deposition-point-tool-producer'),
            width: 'resolve'
        }).on('select2:select', function(e) {
            this_._entitySelectedForProducer = e.params.data;
            this_._entitySelectedForProducer.ClientType = (this_._entitySelectedForProducer.ClientType === null || this_._entitySelectedForProducer.ClientType === undefined)? "": this_._entitySelectedForProducer.ClientType;
            this_._entitySelectedForProducer.Fraction = (this_._entitySelectedForProducer.Fraction === null || this_._entitySelectedForProducer.Fraction === undefined)? "": this_._entitySelectedForProducer.Fraction;
            this_._entitySelectedForProducer.idClientType = (this_._entitySelectedForProducer.idClientType === null || this_._entitySelectedForProducer.idClientType === undefined)? "": this_._entitySelectedForProducer.idClientType;
        });
    }
};